// src/pages/AgendaCall.js
import React, { useEffect, useMemo, useState, useCallback } from "react";
import "../css_agenda/common.css";
import { useAuth } from "../context/AuthContext";
import { postForm } from "../api/api";
/* ---------- TEMA + COSTANTI (unico file) ---------- */

/* ---- icone campanello ---- */
const BELL_OK_IMG     = "/ImmaginiBottoni/campanello_on.png";     // riusa l'icona "on"
const BELL_BROKEN_IMG = "/ImmaginiBottoni/campanello_off.png"; // nuova icona “rotto”
const BELL_OFF_IMG    = "/ImmaginiBottoni/campanello_off.png";    // già usata
const PRES_ON_IMG  = "/ImmaginiBottoni/libemax_on.png";
const PRES_OFF_IMG = "/ImmaginiBottoni/libemax_off.png";

// mapping stato → etichetta + icona
const BELL_STATES = [
  { key: "ok",    label: "Campanello OK",   img: BELL_OK_IMG   },
  { key: "rotto", label: "Campanello rotto",img: BELL_BROKEN_IMG },
  { key: "off",   label: "No campanello",   img: BELL_OFF_IMG  },
];



/* ---- operatore corrente (provvisorio) ----
   Se in futuro userai useAuth: sostituisci 1 con user.id */



const API = "/preventivi/agenda/api";

/* Griglia principale (slot nella tabella) */
const SLOTS_PER_FASCIA = 8;          // capienza “UI” per fascia (resta 8)
const GRID_COLS = 2;                 // 2 colonne × 4 righe = 8
const GRID_ROWS = Math.ceil(SLOTS_PER_FASCIA / GRID_COLS);

/* Misure dello slot UI */
const SLOT_W = 140;
const SLOT_H = 60;
const SLOT_GAP = 8;

/* Palette / brand */
const BRAND_RED         = "#c62828";
const BRAND_RED_DARK    = "#ad1f1f";
const BRAND_RED_SOFT_BG = "rgba(198, 40, 40, .06)";
const BRAND_RED_SOFT_RING = "rgba(198, 40, 40, .25)";

/* Accenti / gradient */
const ACCENT_CYAN    = "#06b6d4"; // bordo slot “ok”
const BRAND_GRADIENT = "linear-gradient(180deg, rgba(198,40,40,.14) 0%, rgba(198,40,40,.08) 100%)";

/* Soft border */
const SOFT_BORDER = "#e5e7eb";

/* Slot typography */
const SLOT_RADIUS = 10;
const SLOT_FONT   = 10;


const CANCEL_PATTERN = "/ImmaginiBottoni/gear.png";
const CANCEL_TILE_PX = 140; // prova 120/140/160 a gusto


/* ---------- costanti ---------- */








// NB: nomi generici perché possono anche essere tutte e 3 pomeridiane
const FASCIE = [
  { code: "M", label: "Fascia 1", time: "09:00" },
  { code: "P", label: "Fascia 2", time: "14:00" },
  { code: "S", label: "Fascia 3", time: "18:00" },
];

const SLOT_TIME = { M: "09:00", P: "14:00", S: "18:00" };

const ZONE = [
  { id: 1, label: "Verona" },
  { id: 2, label: "Modena" },
  { id: 3, label: "Novara" },
  { id: 4, label: "Milano Sud" },
  { id: 5, label: "Milano Nord" },
];

/* === SHARED UI (colori + visibilità allineate con AgendaPro) === */
const toDate = (s) => (s ? new Date(String(s).replace(" ", "T")) : null);
const dayDiff = (a, b) => {
  const d1 = new Date(a.getFullYear(), a.getMonth(), a.getDate());
  const d2 = new Date(b.getFullYear(), b.getMonth(), b.getDate());
  return Math.round((d1 - d2) / 86400000);
};

const UI_COLORS = {
  grey:      '#9aa1a6', // prenotato
  green:     '#59c36a', // confermato
  blue:      '#38bdf8', // rilevatore assegnato
  pink:      '#f7b1c3', // rilievo non buono
  gold:      '#f5c542', // fase senior
  darkGreen: '#0f6c3d', // senior chiuso
  red:       '#e24d4d', // senior non chiuso
  orange:    '#f6a623', // BLOCCO
  borderRed: '#d0021b',
  borderGold:'#d4a017',
  lemon:     '#fff79a', // S10: "da spostare"
};



/* === UI by DB state (S0..S8) === ... */
const UI_BY_CODE = {
  S0: { bg: UI_COLORS.grey,      border: null,      showOnCall: true  },
  S1: { bg: UI_COLORS.green,     border: null,      showOnCall: true  },
  S2: { bg: UI_COLORS.blue,      border: null,      showOnCall: true  },
    S3: { bg: UI_COLORS.gold,      border: UI_COLORS.borderRed, showOnCall: true  }, // passa al senior (oro)

  S4: { bg: UI_COLORS.gold,      border: null,      showOnCall: false },
  S5: { bg: UI_COLORS.green,     border: null,      showOnCall: false },
  S5S:{ bg: UI_COLORS.gold,      border: UI_COLORS.borderRed, showOnCall: false },
  S6: { bg: UI_COLORS.darkGreen, border: UI_COLORS.borderGold, showOnCall: false },
  S7: { bg: UI_COLORS.red,       border: null,      showOnCall: false },
  S8: { bg: "#fee2e2",           border: "#ef4444", showOnCall: true  },
  S10: { bg: UI_COLORS.lemon,     border: null,                 showOnCall: true  }, // da spostare
};

function deriveEventUIFromRaw(row, now = new Date()) {
  const codeRaw = String(row?.ui_state_code || "").toUpperCase();
  const stato   = String(row?.stato || "").toLowerCase();
  const confirmed = !!row?.confirmed_at || stato === "confermato";
  const hasRil = Number(row?.rilevatore_id || 0) > 0;
  const hasSnr = Number(row?.senior_id || 0) > 0;
  const esitoSnr = String(row?.senior_esito || row?.esito_senior || "").toLowerCase();
  const wantSr = Number(row?.want_senior || row?.pass_to_senior || 0) === 1;

  // 1) Se è annullato, forzo S8
  if (stato === "annullato") {
    return { bg: UI_BY_CODE.S8.bg, border: UI_BY_CODE.S8.border, state: "S8", showOnCall: true, showOnPro: true };
  }

  // 🟡 da spostare → S10 (giallo chiaro)
  if (stato === "da_spostare") {
    return { bg: UI_BY_CODE.S10.bg, border: UI_BY_CODE.S10.border, state: "S10", showOnCall: true, showOnPro: true };
  }




  // 2) Se ho un ui_state_code valido uso quello
  if (codeRaw && UI_BY_CODE[codeRaw]) {
    const def = UI_BY_CODE[codeRaw];
    // bordo rosso entro 24h se non confermato (S0/S3)
    let border = def.border;
    try {
      const start = toDate(row?.start_dt || row?.start);
      if (!confirmed && start && dayDiff(start, now) === 1 && !border) {
        border = UI_COLORS.borderRed;
      }
    } catch {}
    return { bg: def.bg, border, state: codeRaw, showOnCall: def.showOnCall, showOnPro: true };
  }

  // 3) Fallback “intelligente” quando il BE non manda ui_state_code
  let inferred = "S0"; // prenotato/grigio
  if (confirmed) {
    inferred = "S1";
  } else if (wantSr) {
    // passa al senior = ORO (S3). NB: PRIMA di hasRil per non finire S2.
    inferred = "S3";
  } else if (hasRil) {
    inferred = "S2";
  }


  // Senior: esito
  if (esitoSnr === "chiuso")       inferred = "S6";
  else if (esitoSnr === "non_chiuso") inferred = "S7";
  else if (hasSnr && !esitoSnr)    inferred = "S5S";

  const def = UI_BY_CODE[inferred] || UI_BY_CODE.S0;

  // bordo rosso entro 24h se non confermato
  let border = def.border;
  try {
    const start = toDate(row?.start_dt || row?.start);
    if (!confirmed && start && dayDiff(start, now) === 1 && !border) {
      border = UI_COLORS.borderRed;
    }
  } catch {}

  return { bg: def.bg, border, state: inferred, showOnCall: def.showOnCall, showOnPro: true };
}







/* ---------- flag fascia S ---------- */
const USE_SERA = true;

/** Determina fascia da una data (M/P/S) */
const fasciaFromDate = (d) => {
  const h = (d instanceof Date ? d : new Date(d)).getHours();
  if (h < 13) return "M";
  if (h < 18) return "P";
  return USE_SERA ? "S" : "P";
};

/** BLOCCO sugli oggetti “raw” */
const isBlockEventRaw = (e) => {
  const name  = String(e?.nome_cliente || e?.cliente_nome || "").trim().toUpperCase();
  const note  = String(e?.note || "").toUpperCase();
  const stato = String(e?.stato || "").toLowerCase();
  return name === "BLOCCO" || note.includes("[BLOCK") || note.includes("[LAST:BLOCK]") || stato.includes("bloc");
};

/** Evento attivo (da contare per capienza) */
const isActiveEventRaw = (e) => {
  const st = String(e?.stato || "").toLowerCase();
  return st !== "annullato" && st !== "no_show";
};





/** Evento che consuma 1 rilevatore attivo (solo prima fase) */
function countsAsRilevatoreSlot(e) {
  if (!e || typeof e !== "object") return false;
  if (isBlockEventRaw(e)) return false;

  const stato = String(e.stato || "").toLowerCase();
  const code  = String(e.ui_state_code || "").toUpperCase();
  const esitoSnr = String(e.senior_esito || e.esito_senior || "").toLowerCase();
  const posaFlag = Number(e.posa_flag || 0) === 1;

  // stati “post-rilevatore” da ESCLUDERE
  if (stato === "annullato") return false;
  if (stato === "chiuso") return false;
  if (stato === "senior_da_programmare") return false;
  if (stato === "no_show") return false;
  if (stato === "da_spostare") return false;

  // senior chiuso / non chiuso → fuori
  if (esitoSnr === "chiuso" || esitoSnr === "non_chiuso") return false;

  // già in POSA → fuori (se usi un flag del genere)
  if (posaFlag) return false;

  // codici UI "post-prima fase" da ESCLUDERE
  if (["S3", "S4", "S5", "S5S", "S6", "S7", "S8", "S10"].includes(code)) {
    return false;
  }

  // contano solo gli appuntamenti di prima fase:
  // prenotato / confermato / assegnato (S0/S1/S2 o simili)
  if (["prenotato", "confermato", "assegnato"].includes(stato)) return true;

  return false;
}

/* === Utility generiche === */
const pad2 = (n) => String(n).padStart(2, "0");
const ymd = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
const addDays = (d, days) => { const x = new Date(d); x.setDate(x.getDate() + days); return x; };
const weekdayShort = (d) => ["dom","lun","mar","mer","gio","ven","sab"][d.getDay()];

/** Somma minuti a "HH:MM" → "HH:MM" */
const addMinutesHHMM = (hhmm, minutes) => {
  if (!/^\d{2}:\d{2}$/.test(hhmm || "")) return "00:00";
  const [h, m] = hhmm.split(":").map(Number);
  const dt = new Date(2000, 0, 1, h, m + minutes, 0, 0);
  return `${pad2(dt.getHours())}:${pad2(dt.getMinutes())}`;
};

/** Normalizza "H:MM" → "HH:MM" */
const parseHHMM = (s) => {
  const m = String(s || "").match(/(\d{1,2}):(\d{2})/);
  if (!m) return null;
  return `${pad2(+m[1])}:${m[2]}`;
};

/** Mappa orario "HH:MM" a M/P/S */
function fasciaForTime(hhmm) {
  const v = parseHHMM(hhmm);
  if (!v) return "M";
  const [h, m] = v.split(":").map(Number);
  const mins = h * 60 + m;
  if (mins < 13 * 60) return "M";
  if (mins < 18 * 60) return "P";
  return USE_SERA ? "S" : "P";
}



/** Colore testo automatico in base allo sfondo (#rrggbb) */
function textColorForBg(hex = "#ffffff") {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!m) return "#111";
  const r = parseInt(m[1], 16), g = parseInt(m[2], 16), b = parseInt(m[3], 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000; // luminanza percettiva
  return yiq >= 160 ? "#111" : "#fff";              // testo scuro su chiaro, bianco su scuro
}



/* BLOCCO: vietato se lo slot NON è libero (anche annullati) */


/* geocodifica instantanea per km rilevatori */
// geocodifica instantanea per km rilevatori (POST form-urlencoded)
// geocodifica: invio form-urlencoded + alias nomi (indirizzo/address, cap/zip, comune/city)
async function geocodeAddress({ indirizzo = "", cap = "", comune = "" }) {
  const addr = String(indirizzo || "").trim();
  const zip  = String(cap || "").trim();
  const city = String(comune || "").trim();

  if (!addr && !zip && !city) return { ok: false };  // niente query → niente chiamata

  try {
    const body = new URLSearchParams();
    // nomi “canonici”
    body.set("indirizzo", addr);
    body.set("cap", zip);
    body.set("comune", city);
    // alias (nel dubbio soddisfo il PHP)
    body.set("address", addr);
    body.set("zip", zip);
    body.set("city", city);
    body.set("action", "geocode");

    const r = await fetch("/preventivi/agenda/api/geocode_addr.php", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      credentials: "same-origin",
      body,
    });

    const t = await r.text();
    let j = {}; try { j = JSON.parse(t); } catch {}

    if (!r.ok || (j.status && j.status !== "OK")) {
      console.warn("[geo] response", r.status, t.slice(0, 200));
      return { ok: false };
    }

    // accetto lat/lng o lat/lon o latitude/longitude
    const lat = Number(j.lat ?? j.latitude ?? j.geo_lat ?? NaN);
    const lng = Number(j.lng ?? j.lon ?? j.longitude ?? j.geo_lng ?? NaN);
    if (Number.isFinite(lat) && Number.isFinite(lng)) {
      return { ok: true, lat: +lat.toFixed(6), lng: +lng.toFixed(6), precision: j.precision || "approx" };
    }
  } catch (err) {
    console.warn("[geo] errore:", err);
  }
  return { ok: false };
}






/* === HTTP helpers === */
async function apiGet(url) {
  const r = await fetch(url, { credentials: "same-origin" });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.message || `HTTP ${r.status}`);
  return j;
}





/* === utilità testo/note === */
const firstNonEmpty = (...vals) => {
  for (const v of vals) {
    const s = (v ?? "").toString().trim();
    if (s) return s;
  }
  return "";
};
// tag [KEY:VAL] nelle note
function getNoteTag(note, key) {
  const re = new RegExp(`\\[${key}:([^\\]]+)\\]`, "i");
  const m = String(note || "").match(re);
  return m ? m[1].trim() : null;
}
function upsertNoteTag(note, key, value) {
  const re = new RegExp(`\\[${key}:[^\\]]+\\]`, "ig");
  const base = String(note || "").replace(re, "").trim();
  return `${base} [${key}:${value}]`.trim();
}

/* === quantità === */
const toInt = (v) => {
  const n = parseInt(String(v ?? "").replace(/[^\d]/g, ""), 10);
  return Number.isFinite(n) && n > 0 ? n : 0;
};
const buildQta = ({ qFin, qPF, qPor, qBli, qAltro }) => {
  const fin = toInt(qFin), pf = toInt(qPF), por = toInt(qPor), bli = toInt(qBli), alt = toInt(qAltro);
  return {
    total: fin + pf + por + bli + alt,
    descr: `Finestre:${fin}, Porte-finestre:${pf}, Portoncino:${por}, Blindato:${bli}, Altro:${alt}`,
    pretty:`Fin=${fin}, PF=${pf}, Por=${por}, Bli=${bli}, Altro=${alt}`,
  };
};
const parseQtaDescr = (s = "") => {
  const pick = (...res) => { for (const re of res) { const m = s.match(re); if (m) return toInt(m[1]); } return 0; };
  return {
    qFin:   pick(/Finestre\s*[:=]\s*(\d+)/i,     /(?:^|\b)Fin\s*=\s*(\d+)/i),
    qPF:    pick(/Porte[-\s]?finestre\s*[:=]\s*(\d+)/i, /(?:^|\b)PF\s*=\s*(\d+)/i),
    qPor:   pick(/Portoncino\s*[:=]\s*(\d+)/i,   /(?:^|\b)Por\s*=\s*(\d+)/i),
    qBli:   pick(/Blindato\s*[:=]\s*(\d+)/i,     /(?:^|\b)Bli\s*=\s*(\d+)/i),
    qAltro: pick(/Altro\s*[:=]\s*(\d+)/i,        /(?:^|\b)Altro\s*=\s*(\d+)/i),
  };
};

/* ---------- slots: parser robusto + fallback ---------- */
function normalizeSlots(raw) {
  const map = new Map();
  const capMeta =
    Number(raw?.meta?.capacity_per_fascia) ||
    Number(raw?.meta?.cap_per_fascia) ||
    6;

  const arr = Array.isArray(raw) ? raw : raw?.slots || raw?.items || raw?.data || [];
  const KEYS = { M: ["M", "m", "mattina"], P: ["P", "p", "pomeriggio"], S: ["S", "s", "sera"] };

  for (const s of arr) {
    if (!s || typeof s !== "object") continue;
    const date = s.date || s.giorno || s.day || s.ymd;
    if (!date) continue;

    for (const code of ["M", "P", "S"]) {
      const names = KEYS[code];
      let val = null;
      for (const n of names) if (s[n] !== undefined) { val = s[n]; break; }
      if (val === null || val === undefined) continue;

      let free = 0, cap = 0;
      if (typeof val === "number") {
        const used = Math.max(0, val);
        cap  = capMeta || 6;
        free = Math.max(0, cap - used);
      } else if (val && typeof val === "object") {
        const used = Number(val.used ?? 0) || 0;
        cap  = Number(val.capacity ?? val.cap ?? val.max ?? capMeta) || capMeta || 6;
        free = Number(val.free ?? Math.max(0, cap - used)) || 0;
      }
      if (!cap) cap = capMeta || 6;
      if (free > cap) free = cap;

      map.set(`${date}|${code}`, { free, cap });
    }
  }
  return { map, capMeta: capMeta || 6 };
}

function buildDefaultSlots(startYmd, days, cap = 6) {
  const m = new Map();
  const d0 = new Date(startYmd + "T00:00:00");
  for (let i = 0; i < (Number(days) || 7); i++) {
    const d = addDays(d0, i);
    const keyDate = ymd(d);
    for (const code of ["M", "P", "S"]) {
      m.set(`${keyDate}|${code}`, { free: cap, cap });
    }
  }
  return { map: m, capMeta: cap };
}





// costruisce mappa "giorno|fascia" -> n° rilevatori bloccati da overlays
// costruisce mappa "giorno|fascia" -> n° rilevatori bloccati da overlays
// costruisce mappa "giorno|fascia" -> info blocco overlays
// value: { blocked: nRilevatori, globalRil: true/false }
function buildOverlayBlocks(rows = []) {
  const out = {};

  const getArr = (v) => {
    if (!v) return [];
    if (Array.isArray(v)) return v;
    try {
      const a = JSON.parse(v);
      return Array.isArray(a) ? a : [];
    } catch {
      return [];
    }
  };

  for (const ov of rows) {
    const start = String(ov.start_dt || ov.start || "");
    if (!start) continue;

    const day   = start.slice(0, 10);
    const hhmm  = start.slice(11, 16) || "09:00";
    const fascia = fasciaForTime(hhmm); // M / P / S
    const key    = `${day}|${fascia}`;

    const prev = out[key] || { blocked: 0, globalRil: false };

    // quanti rilevatori sono stati selezionati esplicitamente
    const ril = getArr(
      ov.rilevatori_json ??
      ov.rilevatori ??
      ov.rilevatori_ids ??
      ov.rilevatori_list
    );
    const countLocal = ril.length;

    // flag evento aziendale per TUTTI i rilevatori
    const isGlobalRil =
      Number(ov.global_rilevatori ?? ov.is_global_ril ?? 0) === 1;

    out[key] = {
      blocked: prev.blocked + countLocal,
      globalRil: prev.globalRil || isGlobalRil,
    };
  }

  return out;
}






/* ====== Ricerca/singolo spostamento (component esterno, stateless) ====== */
/* ====== Ricerca/singolo spostamento (component esterno, stateless) ====== */
/* ===== Cerca e sposta appuntamento esistente (con tasto Cerca + autocompilazione) ===== */
function ExistingSearch({
  zonaId, date, startHHMM, endHHMM, onPrefill, onMoved, canAccept, freeBlock, opId,
}) {
  const BORDER = (typeof SOFT_BORDER !== "undefined") ? SOFT_BORDER : "#e5e7eb";
  const BRAND  = (typeof BRAND_RED   !== "undefined") ? BRAND_RED   : "#c62828";

  const [q, setQ]           = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [items, setItems]   = React.useState([]);

  const doSearch = React.useCallback(async () => {
    const term = (q || "").trim();
    if (term.length < 2) { setItems([]); return; }
    try {
      setLoading(true);
      const url = `${API}/search_event.php?q=${encodeURIComponent(term)}&zona_id=${zonaId}&limit=20`;
      const r = await fetch(url, { credentials: "same-origin" });
      const j = await r.json().catch(() => ({}));
const list = Array.isArray(j.items) ? j.items
           : Array.isArray(j.results) ? j.results
           : [];
setItems(list);
    } catch {
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [q, zonaId]);

  const toSql = (ymd, hhmm) => `${ymd} ${hhmm}:00`;

  const doMoveHere = async (hit) => {
  const start_dt = toSql(date, startHHMM);
  const end_dt   = toSql(date, endHHMM || startHHMM);

  // fascia calcolata dall'ora destinazione (M/P/S)
  const fasciaDb =
    (() => {
      const h = parseInt(startHHMM.slice(0, 2), 10);
      if (h < 13) return "M";
      if (h < 18) return "P";
      return "S";
    })();

  try {
    if (canAccept) {
      const chk = canAccept(date, startHHMM, hit.id);
      if (!chk.ok) {
        alert("Fascia piena: nessuno slot disponibile.");
        return;
      }
      if (chk.needUnblock && chk.blockId && freeBlock) {
        await freeBlock(chk.blockId);
      }
    }
  } catch (e) {
    alert(e?.message || "Errore nella gestione capienza");
    return;
  }

  if (!window.confirm(`Spostare #${hit.id} (“${hit.nome_cliente}”) alle ${startHHMM} del ${date}?`)) {
    return;
  }

  try {
    // 1) sposta data/ora/fascia sul server
    const body = {
      id: Number(hit.id),
      start_dt,
      end_dt,
      zona_id: Number(zonaId) || undefined,
      fascia: fasciaDb,
      updated_by_operator_id: opId,
    };
    const r = await fetch(`${API}/move_event.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(body),
    });
    const j = await r.json().catch(() => ({}));
    if (!r.ok || j.status !== "OK") {
      throw new Error(j.message || `HTTP ${r.status}`);
    }

    // 2) aggiorna i TAG nelle note (PF / ORA / LAST)
    try {
      let note = String(hit.note || "");
      note = upsertNoteTag(note, "PF",  fasciaDb);
      note = upsertNoteTag(note, "ORA", startHHMM);
      note = upsertNoteTag(note, "LAST", "move");

      await postForm(`${API}/update_event.php`, {
        id: Number(hit.id),
        note,
        ui_last_action: "move_search",
        updated_by_operator_id: opId,
      });
    } catch (e2) {
      // il fallimento del ritocco note NON blocca lo spostamento
      console.warn("update note after move (search) failed:", e2);
    }

    onMoved?.();
  } catch (e) {
    alert(e?.message || "Errore spostamento");
  }
};


  const doPrefill = (hit) => {
    onPrefill?.({
      nome_cliente:      hit.nome_cliente || "",
      cliente_telefono:  hit.cliente_telefono || "",
      cliente_email:     hit.cliente_email || hit.email || "",
      cliente_indirizzo: hit.cliente_indirizzo || "",
      comune:            hit.comune || "",
      cap:               hit.cap || "",
      note:              hit.note || "",

      fori_qta:          hit.fori_qta ?? null,
      fori_descr:        hit.fori_descr ?? "",
    });
  };


  const fmtTime = (s) => {
    if (!s) return "";
    const d = new Date(String(s).replace(" ", "T"));
    const p = (n) => String(n).padStart(2, "0");
    return `${p(d.getDate())}/${p(d.getMonth() + 1)} ${p(d.getHours())}:${p(d.getMinutes())}`;
  };

  return (
    <div>
      {/* input + bottone a destra, nessun overlay */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 8 }}>
        <input
          placeholder="cerca nome/telefono…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); doSearch(); } }}
          style={{ width: "100%", padding: 10, borderRadius: 999, border: `1px solid ${BORDER}`, fontSize: 14 }}
        />
        <button
          type="button"
          onClick={doSearch}
          disabled={loading}
          style={{ padding: "8px 14px", borderRadius: 10, border: `1px solid ${BRAND}`, background: "#fee2e2", color: BRAND, fontWeight: 800, cursor: "pointer", minWidth: 88 }}
        >
          {loading ? "…" : "Cerca"}
        </button>
      </div>

      {/* risultati */}
      {(!loading && q.trim() && items.length === 0) && (
        <div style={{ marginTop: 6, fontSize: 13, opacity: .8 }}>Nessun risultato.</div>
      )}

      {!!items.length && (
  <div
    style={{
      marginTop: 6,
      display: "grid",
      gap: 6,
      border: `1px dashed ${BORDER}`,
      borderRadius: 8,
      padding: 8,
      background: "#fff",

      // 👇 AGGIUNTE per scroll se tanti risultati
      maxHeight: 260,          // alza/abbassa se vuoi
      overflowY: "auto",
    }}
  >
    {items.map((it) => (
      <div
        key={it.id}
        style={{
          border: `1px solid ${BORDER}`,
          borderRadius: 10,
          padding: 8,
          display: "grid",
          gridTemplateColumns: "1fr auto auto",
          gap: 8,
          alignItems: "center",
        }}
      >
              <div style={{ minWidth: 0 }}>
                <div style={{ fontWeight: 800, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  #{it.id} · {it.nome_cliente}
                </div>
                <div style={{ fontSize: 12, opacity: 0.8 }}>
                  📞 {it.cliente_telefono || "—"} · 🗓 {fmtTime(it.start_dt)}
                </div>
                {!!it.cliente_indirizzo && (
                  <div style={{ fontSize: 12, opacity: 0.8, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    📍 {it.cliente_indirizzo}{it.comune ? `, ${it.comune}` : ""}{it.cap ? ` (${it.cap})` : ""}
                  </div>
                )}
              </div>

              <button
                type="button"
                onClick={() => doPrefill(it)}
                title="Precompila i campi"
                style={{ padding: "6px 10px", borderRadius: 8, border: `1px solid ${BORDER}`, background: "#fff", cursor: "pointer" }}
              >
                Precompila
              </button>

              <button
                type="button"
                onClick={() => doMoveHere(it)}
                title="Sposta qui"
                style={{ padding: "6px 10px", borderRadius: 8, border: `1px solid ${BRAND}`, background: "#fee2e2", color: BRAND, fontWeight: 800, cursor: "pointer" }}
              >
                Sposta qui
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}






/* helper: inizio settimana (lunedì) per una data YYYY-MM-DD */
const startOfWeekMonday = (ymdStr) => {
  const d = new Date((ymdStr || ymd(new Date())) + "T00:00:00");
  const diff = (d.getDay() + 6) % 7; // lun=1 … dom=0 -> 0..6
  d.setDate(d.getDate() - diff);
  return ymd(d);
};

/* ======================= COMPONENTE PRINCIPALE ======================= */
export default function AgendaCall() {
  const { user } = useAuth?.() || {};
  const opId = Number(user?.id) || 0;   // 👈 id operatore loggato
  /* ====== FILTRI DI BASE ====== */
  const [start, setStart]   = useState(() => ymd(new Date()));
  const [days, setDays]     = useState(7);
    const [zonaId, setZonaId] = useState(() => {
    // 1) prova da localStorage (stessa key usata in AgendaPro)
    try {
      const saved = window.localStorage.getItem("agendaZonaId");
      if (saved != null && saved !== "") {
        const n = Number(saved);
        if (Number.isFinite(n) && n > 0) return n;
      }
    } catch {}

    // 2) fallback: zona dell’utente, se c’è
    const z = Number(user?.zona_id || 0);
    if (Number.isFinite(z) && z > 0) return z;

    // 3) fallback finale: prima zona della lista (Verona)
    return ZONE[0].id;
  });

  const [loading, setLoading] = useState(false);
  const [tick, setTick]     = useState(0);

/* ====== DATI CARICATI ====== */
const [slotMap, setSlotMap]       = useState(new Map());
const [capDefault, setCapDefault] = useState(6);
const [evBuckets, setEvBuckets]   = useState({}); // `${date}|${fascia}` -> events[]

// override rilevatori (senior che danno una mano)
// chiave: `${date}|${fascia}` -> delta intero (+1, -1, ecc.)
const [capOverrides, setCapOverrides] = useState({});


// overlay: quanti rilevatori sono bloccati per ogni giorno|fascia
const [overlayBlocks, setOverlayBlocks] = useState({}); // key = "YYYY-MM-DD|M/P/S" -> nRilevatoriBloccati




  // === RILEVATORI ATTIVI PER ZONA (da DB) ===
  const [activeRil, setActiveRil] = useState(null);    // numero per la zona corrente
  const [highlightExtra, setHighlightExtra] = useState(true);

  // Salva sempre la zona corrente in localStorage (condivisa con AgendaPro)
  useEffect(() => {
    try {
      if (Number.isFinite(Number(zonaId)) && Number(zonaId) > 0) {
        window.localStorage.setItem("agendaZonaId", String(zonaId));
      }
    } catch {}
  }, [zonaId]);




/* helper: vero se nello slot c'è QUALSIASI evento non BLOCCO (annullati compresi) */
const hasAnyAppointmentNonBlock = useCallback((date, fascia) => {
  const key = `${date}|${fascia}`;
  const arr = evBuckets[key] || [];
  // TRUE se c’è almeno un evento che NON è BLOCCO (gli annullati contano)
  return arr.some((e) => !isBlockEventRaw(e));
}, [evBuckets]);







// sposta la finestra di visualizzazione avanti/indietro di "days"
const shiftWindow = useCallback((dir) => {
  const span = Number(days) || 7;
  const d0 = new Date(start + "T00:00:00");
  setStart( ymd( addDays(d0, dir * span) ) );
}, [start, days]);





  /* ====== STATO MODALE ====== */
  const emptyModal = {
    open: false,
    mode: "new",
    eventId: null,
    date: "",
    fascia: "M",
    time: "09:00",
    lunga: false,
    nome: "",
    bellState: "ok",    // 🔔 “campanello”
    telefono: "",
    email: "",          // 👈 NUOVO
    comune: "",
    cap: "",
    indirizzo: "",
    note: "",
    qFin: "",
    qPF: "",
    qPor: "",
    qBli: "",
    qAltro: "",
    moveOpen: false,
    moveDate: "",
    moveTime: "",
    moveReason: "",
    stato: "prenotato",
    pickerOpen: false,

    presenze: false,    // 🕒 inserito su app Presenze
    presenzeBy: null,   // id operatore che ha fatto l’inserimento
  };

  const [modal, setModal] = useState(emptyModal);

  /* ====== LISTA GIORNI (FILTRO) ====== */
  const daysList = useMemo(() => {
    const d0 = new Date(start + "T00:00:00");
    return Array.from({ length: Number(days) || 7 }, (_, i) => addDays(d0, i));
  }, [start, days]);

  /* ====== REFRESH/SYNC ====== */
  const refetch = useCallback(() => setTick((t) => t + 1), []);
  const notifyChanged = useCallback(() => {
    try { new BroadcastChannel("agenda_sync").postMessage({ type: "changed", zonaId }); } catch {}
  }, [zonaId]);



  // carica i rilevatori attivi ogni volta che cambia la zona
  useEffect(() => {
    let abort = false;

    async function fetchActiveRil() {
      try {
        const j = await apiGet(`/preventivi/api/rilevatori_attivi.php?zona_id=${zonaId}`);
        if (abort) return;
        const n = Number(j.active ?? j.count ?? 0);
        setActiveRil(Number.isFinite(n) ? n : 0);
      } catch (err) {
        console.warn("Errore caricando rilevatori attivi:", err);
        if (!abort) setActiveRil(0);
      }
    }

    fetchActiveRil();
    return () => { abort = true; };
  }, [zonaId]);






  // auto-refresh se rientri nella tab/finestra
  useEffect(() => {
    const onFocus = () => refetch();
    const onVis = () => { if (!document.hidden) refetch(); };
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVis);
    return () => {
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVis);
    };
  }, [refetch]);

  // sincronizza con altre tab (AgendaPro compresa)
  useEffect(() => {
    let ch;
    try {
      ch = new BroadcastChannel("agenda_sync");
      ch.onmessage = (ev) => {
        const data = ev?.data || {};
        if (data.type === "changed" && (!data.zonaId || data.zonaId === zonaId)) {
          refetch();
        }
      };
    } catch {}
    return () => { try { ch?.close(); } catch {} };
  }, [refetch, zonaId]);

  /* ====== PICKER SETTIMANA (lun→dom) ====== */
  const [pickerStart, setPickerStart] = useState(() => startOfWeekMonday(start));
  useEffect(() => { setPickerStart(startOfWeekMonday(start)); }, [start]);

  /* ---------- aperture modali ---------- */
  function openNew(date, fascia) {
    const f = FASCIE.find((x) => x.code === fascia) || FASCIE[0];
    setPickerStart(date); // allinea il picker alla settimana della data scelta
    setModal({
      ...emptyModal,
      open: true,
      mode: "new",
      date,
      fascia: f.code,
      time: f.time,
      moveDate: date,
      moveTime: f.time,
    });
  }

  // apertura “universale” (parte dal filtro corrente e apre il picker)
  function openNewUniversal() {
    const d0 = start;
    setPickerStart(startOfWeekMonday(d0));
    setModal({
      ...emptyModal,
      open: true,
      mode: "new",
      pickerOpen: true,
      date: d0,
      fascia: "M",
      time: SLOT_TIME.M,
      moveDate: d0,
      moveTime: SLOT_TIME.M,
    });
  }

  function openEdit(e) {
  const d = (e.start_dt || "").slice(0, 10);
// mapping ampio (+ fallback da tag nota)
const comune = firstNonEmpty(
  e.comune, e.citta, e.cliente_comune, e.paese, e.paese_citta, e.localita, e.city, e.town,
  getNoteTag(e.note, "CITTA")
);
const cap = firstNonEmpty(
  e.cap, e.CAP, e.cliente_cap, e.cap_cliente, e.zip, e.zip_code, e.postal_code, e.postalcode,
  getNoteTag(e.note, "CAP")
);
// CAP sanificato SOLO per il prefill nello state (NO uso di `note` qui!)
const capSan = String(cap || "").replace(/\D/g, "").slice(0, 5);

const telefono  = firstNonEmpty(e.cliente_telefono, e.cliente_tel, e.telefono, e.phone);
const indirizzo = firstNonEmpty(e.cliente_indirizzo, e.indirizzo, e.address);

const email = firstNonEmpty(e.cliente_email, e.email);

const oraNota = getNoteTag(e.note, "ORA") || e.start_dt?.slice(11, 16) || SLOT_TIME[e.fascia || "M"];
const pf = (e.fascia || getNoteTag(e.note, "PF") || "M").toUpperCase();
const durMin = (e.end_dt && e.start_dt)
  ? Math.round((new Date(e.end_dt) - new Date(e.start_dt)) / 60000)
  : 60;

// quantità in ingresso (da fori_descr o tag [QTA:])
const qParsed = parseQtaDescr(e.fori_descr || getNoteTag(e.note, "QTA") || e.note || "");

// 🔔🕒 ➂: leggi i tag speciali dalla nota
const bellRaw = (getNoteTag(e.note, "BELL") || "").toLowerCase();
const bellState =
  bellRaw === "rotto" ? "rotto" :
  (bellRaw === "off" || bellRaw === "no") ? "off" :
  bellRaw === "on" ? "ok" : "ok";

const presenze = (getNoteTag(e.note, "PRES") || "") === "1";
const presenzeBy = (() => {
  const v = getNoteTag(e.note, "PRES_BY");
  const n = v ? parseInt(v, 10) : NaN;
  return Number.isFinite(n) ? n : null;
})();


  setPickerStart(startOfWeekMonday(d)); // allinea il picker alla settimana dell’evento

  setModal({
    ...emptyModal,
    open: true,
    mode: "edit",
    eventId: e.id,
    date: d,
    fascia: ["M", "P", "S"].includes(pf) ? pf : "M",
    time: oraNota,
    lunga: durMin >= 120,

    nome: firstNonEmpty(e.nome_cliente, e.cliente_nome, e.nome, "Cliente"),
    telefono,

    comune,
    cap: capSan,
    indirizzo,
    email: email || "",
    // quantità nel form
    qFin: String(qParsed.qFin || ""),
    qPF: String(qParsed.qPF || ""),
    qPor: String(qParsed.qPor || ""),
    qBli: String(qParsed.qBli || ""),
    qAltro: String(qParsed.qAltro || ""),

    note: e.note || "",
    stato: e.stato || "prenotato",
    moveDate: d,
    moveTime: oraNota,

    // 🔔🕒 ➂: stati UI iniziali
    bellState,
    presenze,
    presenzeBy,
  });
}
          // ====== CARICAMENTO slots + eventi ======
  useEffect(() => {
    (async () => {
      try {
        setLoading(true);

        // 1) SLOT (capienza base per M/P/S)
        let sresp = {};
        try {
          sresp = await apiGet(
            `${API}/slots_week.php?from=${start}&days=${days}&zona_id=${zonaId}`
          );
        } catch {}
        let { map: sMap } = normalizeSlots(sresp);

        if (!sMap || sMap.size === 0) {
          sMap = buildDefaultSlots(start, days, SLOTS_PER_FASCIA).map;
        } else {
          // forza capienza minima a 8 per coerenza UI
          const up = new Map();
          for (const [k, v] of sMap.entries()) {
            const cap = Math.max(SLOTS_PER_FASCIA, Number(v.cap) || 0);
            const free = Math.min(Number(v.free) || 0, cap);
            up.set(k, { free, cap });
          }
          sMap = up;
        }
        setSlotMap(sMap);
        setCapDefault(SLOTS_PER_FASCIA);

        // 2) EVENTI (AgendaPro → list_events.php)
        const to = ymd(
          addDays(new Date(start + "T00:00:00"), Number(days) - 1)
        );
        let eresp = {};
        try {
          eresp = await apiGet(
            `${API}/list_events.php?from=${start}&to=${to}&zona_id=${zonaId}`
          );
        } catch {}
        const arr = Array.isArray(eresp?.events)
          ? eresp.events.slice()
          : [];

        // 3) OVERLAYS (blocchi agenda / corsi rilevatori)
        try {
          const oResp = await apiGet(
            `/preventivi/agenda/overlays/list.php?from=${start}&to=${to}&zona_id=${zonaId}`
          );
          const rows = Array.isArray(oResp?.rows) ? oResp.rows : [];
          const blocksMap = buildOverlayBlocks(rows);
          setOverlayBlocks(blocksMap);
        } catch (err) {
          console.warn("overlays list", err);
          setOverlayBlocks({});
        }

        // 4) OVERRIDE capacità rilevatori (senior extra)
        try {
          const oresp = await apiGet(
            `${API}/capacity_override.php?from=${start}&to=${to}&zona_id=${zonaId}`
          );
          console.log("[OVERRIDE RAW]", oresp);

          const map = {};
          if (Array.isArray(oresp.items)) {
            for (const row of oresp.items) {
              const y = row.giorno || row.date || row.ymd;
              const fa = (row.fascia || "").toUpperCase();
              if (!y || !["M", "P", "S"].includes(fa)) continue;
              const k = `${y}|${fa}`;

              const extra     = Number(row.extra ?? 0) || 0;
              const lastDelta = Number(row.last_delta ?? 0) || 0;
              const byName    = (row.last_by_name || "").trim() || null;
              const lastNote  = (row.last_note || "").trim() || "";
              const lastById  = row.last_by_id != null ? Number(row.last_by_id) : null;

              map[k] = { extra, lastDelta, byName, lastNote, lastById };
            }
          }

          console.log("[OVERRIDE MAP]", map);
          setCapOverrides(map);
        } catch (e) {
          console.warn("capacity_override", e);
          setCapOverrides({});
        }

        // 5) Filtra gli eventi visibili per AgendaCall (no post-senior)
        const arrVisible = arr.filter((row) =>
          deriveEventUIFromRaw(row).showOnCall
        );

        // ordine stabile
        arrVisible.sort(
          (a, b) =>
            (a.start_dt || "").localeCompare(b.start_dt || "") ||
            (Number(a.id) || 0) - (Number(b.id) || 0)
        );

        // 6) Bucket: PF -> ORA -> fascia DB -> orario calcolato
        const buckets = {};
        for (const e of arrVisible) {
          const d = (e.start_dt || "").slice(0, 10);

          let pf =
            (getNoteTag(e.note, "PF") || "").toUpperCase() ||
            (getNoteTag(e.note, "ORA")
              ? fasciaForTime(getNoteTag(e.note, "ORA"))
              : "") ||
            (["M", "P", "S"].includes(String(e.fascia || "").toUpperCase())
              ? String(e.fascia).toUpperCase()
              : "") ||
            fasciaForTime((e.start_dt || "").slice(11, 16));

          if (!["M", "P", "S"].includes(pf)) pf = "M";

          const key = `${d}|${pf}`;
          if (!buckets[key]) {
            buckets[key] = [];
          }
          buckets[key].push(e);
        }
        setEvBuckets(buckets);
      } finally {
        setLoading(false);
      }
    })();
  }, [start, days, zonaId, tick]);



  // ——— patch locale di un evento nelle evBuckets (per reattività immediata)
function patchEventLocal(id, patch = {}) {
  setEvBuckets((prev) => {
    const next = { ...prev };
    for (const key of Object.keys(next)) {
      const arr = next[key];
      if (!Array.isArray(arr)) continue;
      const i = arr.findIndex((ev) => Number(ev.id) === Number(id));
      if (i >= 0) {
        next[key] = [...arr];
        next[key][i] = { ...arr[i], ...patch };
      }
    }
    return next;
  });
}


  /* ---------- salvataggi ---------- */
/* ---------- salvataggi ---------- */
/* ---------- salvataggi ---------- */
/* ---------- salvataggi ---------- */
async function submitModal(e) {
  e.preventDefault();
  try {
    const dur = modal.lunga ? 120 : 60;

    // ora realmente digitata (o default della fascia cliccata)
    const oraDigitata = parseHHMM(modal.time) || SLOT_TIME[modal.fascia];
    const fasciaDb = fasciaForTime(oraDigitata);

    // salva con l’ora digitata
    const startDB = `${modal.date} ${oraDigitata}:00`;
    const endDB   = `${modal.date} ${addMinutesHHMM(oraDigitata, dur)}:00`;

    // quantità
    const q = buildQta({
      qFin: modal.qFin,
      qPF: modal.qPF,
      qPor: modal.qPor,
      qBli: modal.qBli,
      qAltro: modal.qAltro,
    });

    // note + tag robusti
    let note = modal.note?.trim() || "";
    note = upsertNoteTag(note, "PF",  fasciaDb);
    note = upsertNoteTag(note, "ORA", oraDigitata);
    if (modal.comune?.trim()) note = upsertNoteTag(note, "CITTA", modal.comune.trim());
    if (modal.cap?.trim())    note = upsertNoteTag(note, "CAP",   modal.cap.trim());
      note = upsertNoteTag(note, "QTA", q.pretty);

    // EMAIL obbligatoria per AgendaCall
    const emailTrim = String(modal.email || "").trim();
    const emailRe   = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailTrim) {
      alert("Inserisci l'indirizzo email del cliente.");
      requestAnimationFrame(() => {
        const el = document.getElementById("email");
        if (el) el.focus();
      });
      return;
    }

    if (!emailRe.test(emailTrim)) {
      alert("Inserisci un indirizzo email valido.");
      requestAnimationFrame(() => {
        const el = document.getElementById("email");
        if (el) el.focus();
      });
      return;
    }

    // CAP sanificato (5 cifre) + guardia hard per submit
    const capClean = String(modal.cap || "").replace(/\D/g, "").slice(0, 5);

    if (capClean.length !== 5) {
      alert("CAP non valido: inserisci 5 cifre.");
      requestAnimationFrame(() => {
        const el = document.getElementById("cap");
        if (el) el.focus();
      });
      return; // blocca la submit
    }

    // tag speciali: campanello + presenze
    // tag speciali: campanello + presenze
    note = upsertNoteTag(note, "BELL", modal.bellState || "ok");
    note = upsertNoteTag(note, "PRES", modal.presenze ? "1" : "0");

    if (modal.presenze) {
      // id operatore (per log/macchine)
      const byId = String(modal.presenzeBy || opId);
      note = upsertNoteTag(note, "PRES_BY", byId);

      // nome operatore (per UI)
      const byName =
        (user?.nome ||
          user?.name ||
          user?.display_name ||
          user?.username ||
          user?.email ||
          `#${byId}`).toString().trim();
      note = upsertNoteTag(note, "PRES_BY_NAME", byName);
    } else {
      // rimuovi eventuali tag se presenze=0
      note = note.replace(/\[PRES_BY:[^\]]+\]/ig, "").trim();
      note = note.replace(/\[PRES_BY_NAME:[^\]]+\]/ig, "").trim();
    }


    // payload comune
    const basePayload = {
      zona_id: Number(zonaId),
      start_dt: startDB,
      end_dt: endDB,
      fascia: fasciaDb,
      nome_cliente: modal.nome || "Cliente",
      cliente_telefono: modal.telefono || "",
      cliente_email: emailTrim.toLowerCase(),  // 👈 NUOVO
      cliente_indirizzo: modal.indirizzo || "",
      comune: modal.comune || "",
      cap: capClean,
      fori_qta: q.total,
      fori_descr: q.descr,
      note,
    };




   // === Geocodifica trasparente ===

   let coords = null;
   if (modal.indirizzo || modal.comune || capClean) {
     const res = await geocodeAddress({ indirizzo: modal.indirizzo, cap: capClean, comune: modal.comune });
     if (res.ok) {
       coords = res;
       basePayload.addr_lat = res.lat;
       basePayload.addr_lng = res.lng;
       // (facoltativo) annota la qualità nelle note, senza sporcare l'interfaccia
       basePayload.note = upsertNoteTag(basePayload.note, "GEO", res.precision);
     }
   }





    if (modal.mode === "new") {
      // CREATE → partiamo sempre da S0 (prenotato)
      const j = await postForm(`${API}/save_event.php`, {
        ...basePayload,
        ui_state_code: "S0",
        ui_last_action: "create",
        created_by_operator_id: opId,
        source: "AGENDA_CALL",              // 👈 NUOVO
      });

      // opzionale: update immediato se serve completare attributi
      const newId = Number(j?.id) || null;
      if (newId) {
        try {
          await postForm(`${API}/update_event.php`, {
            id: newId,
            ...basePayload,
            updated_by_operator_id: opId,
            source: "AGENDA_CALL",          // 👈 NUOVO
          });
        } catch {
          // opzionale, ignora se fallisce
        }
      }
    } else {
      // UPDATE (lo stato UI si gestisce con le azioni rapide)
      await postForm(`${API}/update_event.php`, {
        id: Number(modal.eventId),
        ...basePayload,
        ui_last_action: "update",
        updated_by_operator_id: opId,
        source: "AGENDA_CALL",              // 👈 NUOVO
      });
    }

    // chiudi modale + refresh + sync
    setModal((m) => ({ ...m, open: false }));
    setTick((t) => t + 1);
    notifyChanged();
  } catch (err) {
    const raw = String(err?.message || err || "");

    // Caso specifico: telefono duplicato (vincolo uq_tel_norm_isblock)
    if (/uq_tel_norm_isblock/i.test(raw) || /Duplicate entry .*uq_tel_norm_isblock/i.test(raw)) {
      const tel = String(modal.telefono || "").trim() || "telefono";
      alert(
        [
          "Attenzione:",
          "",
          `esiste già un appuntamento non BLOCCO con lo stesso numero di telefono (${tel}).`,
          "",
          "Usa la funzione \"Cerca appuntamento esistente\" sopra,",
          "oppure modifica il numero di telefono se si tratta di un’altra persona."
        ].join("\n")
      );
    } else {
      // fallback generico
      alert(raw || "Errore salvataggio");
    }
  }
} // 👈 chiusura di submitModal




  
/* ---------- azioni rapide ---------- */
/* ---------- azioni rapide (FIX conferma con tempi coerenti) ---------- */
/* ---------- azioni rapide (definitiva: niente rimbalzi) ---------- */
/* ---------- azioni rapide (CONFIRM / UNCONFIRM robusto) ---------- */
async function quickAction(action) {
  try {
    if (!modal.eventId) return;
    const id = Number(modal.eventId);

    // Tempi coerenti (come submitModal)
    const durMin      = modal.lunga ? 120 : 60;
    const oraDigitata = parseHHMM(modal.time) || SLOT_TIME[modal.fascia];
    const fasciaDb    = fasciaForTime(oraDigitata);
    const startDB     = `${modal.date} ${oraDigitata}:00`;
    const endDB       = `${modal.date} ${addMinutesHHMM(oraDigitata, durMin)}:00`;

    const baseTimes = {
      start_dt: startDB,
      end_dt: endDB,
      fascia: fasciaDb,
      zona_id: Number(zonaId),
    };

    if (action === "confirm") {
      // blocchi tecnici non confermabili
      const isBlock = (String(modal.nome || "").trim().toUpperCase() === "BLOCCO");
      if (isBlock) { alert("Non puoi confermare un BLOCCO."); return; }

      // Percorso “forte” lato BE
      await postForm(`${API}/update_event.php`, {
        id,
        action: "CONFIRM", // BE → stato='confermato', S1, log
        operator_id: opId,
        updated_by_operator_id: opId,
        ...baseTimes,
        ui_last_action: "confirm",
        note: upsertNoteTag(modal.note || "", "LAST", "confirm"),
      });

      // Patch ottimistico
      patchEventLocal(id, {
        stato: "confermato",
        ui_state_code: "S1",
        confirmed_at: new Date().toISOString().slice(0, 19).replace("T", " "),
      });
    }

    else if (action === "unconfirm") {
      // Obiettivo: tornare a prenotato/S0 con log.
      // Ordine tentativi: API moderna → semi-moderna → legacy.
      let ok = false;

      try {
        const r1 = await postForm(`${API}/update_event.php`, {
          id,
          action: "UNCONFIRM",
          operator_id: opId,
          updated_by_operator_id: opId,
          ...baseTimes,
          ui_last_action: "unconfirm",
          note: upsertNoteTag(modal.note || "", "LAST", "unconfirm"),
          ui_lock_version: modal.ui_lock_version,
        });
        ok = !!r1 && (r1.ok === true || r1.ok === 1 || (r1.status && String(r1.status).toUpperCase() === "OK"));
        if (ok && r1.event?.ui_lock_version != null) {
          patchEventLocal(id, { ui_lock_version: r1.event.ui_lock_version });
        }
      } catch {}

      if (!ok) {
        try {
          const r1b = await postForm(`${API}/update_event.php`, {
            id,
            action: "RESET",
            operator_id: opId,
            updated_by_operator_id: opId,
            ...baseTimes,
            ui_last_action: "unconfirm",
            note: upsertNoteTag(modal.note || "", "LAST", "unconfirm"),
            ui_lock_version: modal.ui_lock_version,
          });
          ok = !!r1b && (r1b.ok === true || r1b.ok === 1 || (r1b.status && String(r1b.status).toUpperCase() === "OK"));
          if (ok && r1b.event?.ui_lock_version != null) {
            patchEventLocal(id, { ui_lock_version: r1b.event.ui_lock_version });
          }
        } catch {}
      }

      if (!ok) {
        const r2 = await postForm(`${API}/update_event.php`, {
          id,
          clear_confirm: 1,
          updated_by_operator_id: opId,
          ...baseTimes,
          ui_last_action: "unconfirm",
          note: upsertNoteTag(modal.note || "", "LAST", "unconfirm"),
          ui_lock_version: modal.ui_lock_version,
        });
        ok = !!r2 && (r2.ok === true || r2.ok === 1 || (r2.status && String(r2.status).toUpperCase() === "OK"));
        if (ok && r2.event?.ui_lock_version != null) {
          patchEventLocal(id, { ui_lock_version: r2.event.ui_lock_version });
        }
      }

      if (!ok) throw new Error("La rimozione conferma non è stata accettata dal server.");

      // Patch ottimistico locale
      patchEventLocal(id, { stato: "prenotato", ui_state_code: "S0", confirmed_at: null });
    }

    else if (action === "block") {
      const motivo = prompt("Motivo blocco:", "Operatività") || "Blocco";
      const note2  = upsertNoteTag(
        upsertNoteTag(modal.note || "", "BLOCK", motivo),
        "LAST",
        "block"
      );
      await postForm(`${API}/update_event.php`, {
        id,
        ui_last_action: "block",
        updated_by_operator_id: opId,
        note: note2,
        ...baseTimes,
        ui_lock_version: modal.ui_lock_version,
      });
      // Patch locale: segniamo il blocco anche in client (non cambia colore/stato)
      patchEventLocal(id, { is_block: 1, note: note2 });
    }

    else if (action === "da_spostare") {
      // Marca come "da spostare" (S10 + stato), non assegnabile fino a cambio stato
      await postForm(`${API}/update_event.php`, {
        id,
        action: "DA_SPOSTARE",
        operator_id: opId,
        updated_by_operator_id: opId,
        ...baseTimes,
        ui_last_action: "DA_SPOSTARE",
        note: upsertNoteTag(modal.note || "", "LAST", "da_spostare"),
      });
      // Patch ottimistico
      patchEventLocal(id, { stato: "da_spostare", ui_state_code: "S10" });
    }

    else if (action === "cancel") {
      const motivo = prompt("Motivo annullamento:", "Cliente impossibilitato") || "Annullato";
      const note3  = upsertNoteTag(modal.note || "", "LAST", "cancel");
      const r = await postForm(`${API}/update_event.php`, {
        id,
        action: "CANCEL", // BE → annulla + S7 + log
        operator_id: opId,
        cancelled_by_operator_id: opId,
        updated_by_operator_id: opId,
        ...baseTimes,
        ui_last_action: "cancel",
        motivo,
        note: note3,
        ui_lock_version: modal.ui_lock_version,
      });
      if (r?.event?.ui_lock_version != null) {
        patchEventLocal(id, { ui_lock_version: r.event.ui_lock_version });
      }
      patchEventLocal(id, { stato: "annullato", ui_state_code: "S7", note: note3 });
    }

    // Chiudo modale + sync
    setModal((m) => ({ ...m, open: false }));
    setTick((t) => t + 1);
    notifyChanged();
  } catch (err) {
    console.error(err);
    alert(err?.message || "Errore operazione");
  }
}






function capFor(date, fascia) {
  const meta = slotMap.get(`${date}|${fascia}`) || { cap: capDefault };
  const cap = Math.max(0, Number(meta.cap) || capDefault);
  return Math.min(SLOTS_PER_FASCIA, cap);
}

/** Divide il bucket in appuntamenti reali e BLOCCO, con possibilità di escludere un id */
function splitBucket(date, fascia, excludeId = null) {
  const arr = (evBuckets[`${date}|${fascia}`] || []).filter(
    (e) => excludeId == null || Number(e.id) !== Number(excludeId)
  );
  const real   = arr.filter((e) => !isBlockEventRaw(e) && isActiveEventRaw(e));
  const blocks = arr.filter(isBlockEventRaw);
  return { real, blocks };
}

// ritorna l’array del bucket (tutti gli eventi, reali + blocchi)
function bucketArr(date, fascia) {
  return evBuckets[`${date}|${fascia}`] || [];
}

// vero se l’evento ha un assegnatario (rilevatore o senior)
function isAssigned(e) {
  return Number(e?.rilevatore_id || 0) > 0 || Number(e?.senior_id || 0) > 0;
}




function cellStats(date, fascia) {
  const key = `${date}|${fascia}`;
  const arr = evBuckets[key] || [];

  // capienza "meccanica" (da slots_week) limitata a 8
  const capRaw   = capFor(date, fascia);
  const capCell  = Math.min(SLOTS_PER_FASCIA, capRaw);

  const isCancelled = (e) =>
    String(e?.stato || "").toLowerCase() === "annullato";
  const isConfirmed = (e) =>
    String(e?.stato || "").toLowerCase() === "confermato" ||
    !!e?.confirmed_at;

  // eventi reali che occupano slot (no blocchi, no annullati)
  const realActive = arr.filter(
    (e) => !isBlockEventRaw(e) && !isCancelled(e)
  );
  const cancelled = arr.filter(isCancelled);
  const blocks    = arr.filter(isBlockEventRaw);
  const toConfirm = realActive.filter((e) => !isConfirmed(e)).length;

  // ===== RILEVATORI DISPONIBILI (activeRil) – corsi / overlays / extra =====
  const baseRilZona = Number(activeRil ?? 0);

  // overlays: se global_rilevatori=1 → blocco TUTTI i ril; altrimenti solo quelli selezionati
  const ovBlk = overlayBlocks[key] || { blocked: 0, globalRil: false };
  const blockedByOverlay = ovBlk.globalRil
    ? baseRilZona
    : Number(ovBlk.blocked || 0);

  const baseRil = Math.max(0, baseRilZona - blockedByOverlay);

  // extra / capacity_override (senior che danno una mano)
  const ovObj    = capOverrides[key] || { extra: 0 };
  const override = Number(ovObj.extra || 0);

  const effectiveRil =
    baseRil + (Number.isFinite(override) ? override : 0);

  // capienza effettiva: non più di 8, non più dei rilevatori effettivi
  const capEff = Math.min(
    capCell,
    Number.isFinite(effectiveRil) && effectiveRil >= 0
      ? effectiveRil
      : capCell
  );

  // slot occupati (reali + annullati + BLOCCO)
  const used = realActive.length + cancelled.length + blocks.length;

  // liberi reali tenendo conto di capEff (se corso aziendale ⇒ capEff=0 ⇒ free=0)
  const free = Math.max(0, capEff - Math.min(used, capEff));

  return { cap: capEff, free, cancelled: cancelled.length, toConfirm };
}







// Stats marketing per un giorno (tutte le fasce)
function dayMarketingStats(date) {
  let richiesti  = 0;
  let annullati  = 0;
  let consegnati = 0; // appuntamenti effettivi (non blocco, non annullati)

  const isCancelled = (e) =>
    String(e?.stato || "").toLowerCase() === "annullato";

  for (const f of ["M", "P", "S"]) {
    const key   = `${date}|${f}`;
    const arrAll = evBuckets[key] || [];

    // eventi del giorno/fascia
    const cancelledArr = arrAll.filter(isCancelled);
    const blocksArr    = arrAll.filter(isBlockEventRaw);
    const realArr      = arrAll.filter(
      (e) => !isBlockEventRaw(e) && !isCancelled(e)
    );

    annullati  += cancelledArr.length;
    consegnati += realArr.length;

    // capienza effettiva di quella fascia (rilevatori attivi,
    // overlay aziendali, extra, ecc.) → presa da cellStats
    const cell   = cellStats(date, f);
    const capEff = cell.cap;          // quanti slot "bianchi" ha davvero la fascia

    // slot “bianchi teorici” = capEff
    const whiteSlots = Math.max(0, capEff);

    // richiesti = slot bianchi NON coperti da BLOCCO
    const richiestiFascia = Math.max(
      0,
      whiteSlots - blocksArr.length
    );

    richiesti += richiestiFascia;
  }

  const bucati = Math.max(0, richiesti - consegnati);

  return { richiesti, annullati, bucati, consegnati };
}






/** Verifica se la destinazione (date + hh:mm) può accettare un evento. */
function canAcceptHere(date, hhmm, excludeId = null) {
  const fdb = fasciaForTime(hhmm);
  const cap = capFor(date, fdb);
  const { real, blocks } = splitBucket(date, fdb, excludeId);
  return {
    ok: real.length < cap,
    needUnblock: real.length < cap && (real.length + blocks.length) >= cap && blocks.length > 0,
    blockId: blocks[0]?.id || null,
    fasciaDb: fdb,
  };
}







// Imposta il numero TOTALE di slot extra per una fascia (0,1,2,3...)
// Imposta il numero TOTALE di slot extra per una fascia (0,1,2,3...)
async function toggleExtraOverride(date, fascia) {
  const key = `${date}|${fascia}`;
  const ovObj = capOverrides[key] || { extra: 0 };
  const current = Number(ovObj.extra || 0); // valore attuale (0,1,2,...)

  const fasciaLabel =
    FASCIE.find((x) => x.code === fascia)?.label || `Fascia ${fascia}`;

  // 1) chiedi quanti slot extra totali vuoi
  const input = window.prompt(
    `Quanti slot EXTRA totali vuoi per ${fasciaLabel} del ${date}?\n` +
      `(Valore attuale: ${current}. Metti 0 per eliminarli)`,
    String(Math.max(current, 0))
  );

  if (input === null) {
    // Annulla → non fare nulla
    return;
  }

  const desiredRaw = input.trim();
  const desired = Number(desiredRaw);

  if (
    !Number.isFinite(desired) ||
    !Number.isInteger(desired) ||
    desired < 0 ||
    desired > 6
  ) {
    alert("Inserisci un numero intero tra 0 e 6.");
    return;
  }

  const delta = desired - current;
  if (delta === 0) {
    alert("Valore identico a quello attuale: nessuna modifica.");
    return;
  }

  // 2) nota per il log
  const defaultNote =
    delta > 0
      ? `slot extra ${delta > 0 ? "+" : ""}${delta} (es. extra senior)`
      : `riduzione slot extra ${delta}`;

  const noteInput = window.prompt(
    "Nota per il log (verrà registrata in agenda_capacity_override):",
    defaultNote
  );

  if (noteInput === null) {
    // Annulla → non salvare
    return;
  }

  const note = noteInput.trim() || defaultNote;

  try {
    await postForm(`${API}/capacity_override_save.php`, {
      zona_id: Number(zonaId),
      giorno: date,
      fascia,
      delta_rilevatori: delta,
      note,
      created_by: opId,
    });

    // aggiorna stato locale al nuovo valore + meta ultimo autore
    const userName =
      (user?.nome ||
        user?.name ||
        user?.display_name ||
        user?.username ||
        `user#${opId || ""}`).toString().trim();

    setCapOverrides((prev) => ({
      ...prev,
      [key]: {
        ...(prev[key] || {}),
        extra: desired,
        lastDelta: delta,
        byName: userName,
        lastNote: note,
        lastById: opId,
      },
    }));
  } catch (err) {
    alert(err?.message || "Errore salvataggio capacità extra");
  }
}











// Sposta l'evento aperto in modale
// Sposta l'evento aperto in modale
// Sposta l'evento aperto in modale
async function doMove() {
  if (!modal.eventId) return;

  try {
    const id  = Number(modal.eventId);
    const dur = modal.lunga ? 120 : 60;
    const ora = parseHHMM(modal.moveTime) || SLOT_TIME[modal.fascia];

    // orari SQL
    const startDB = `${modal.moveDate} ${ora}:00`;
    const endDB   = `${modal.moveDate} ${addMinutesHHMM(ora, dur)}:00`;

    // Capienza (escludo l’evento stesso) + eventuale sblocco BLOCCO
    const chk = canAcceptHere(modal.moveDate, ora, id);
    if (!chk.ok) {
      alert("Fascia piena: nessuno slot disponibile nella destinazione.");
      return;
    }
    if (chk.needUnblock && chk.blockId) {
      try {
        await deleteBlockEvent(chk.blockId);
      } catch (err) {
        alert(`Impossibile liberare uno slot BLOCCO: ${err.message || err}`);
        return;
      }
    }

    // spostamento sul server (attribuisci chi sposta)
    const r1 = await postForm(`${API}/move_event.php`, {
      id,
      start_dt: startDB,
      end_dt: endDB,
      fascia: chk.fasciaDb,           // fascia coerente con l’ora scelta
      zona_id: Number(zonaId),
      updated_by_operator_id: opId,   // 👈 CHI sposta
    });
    if (!r1.ok) throw new Error("Spostamento non riuscito");

    // --- RICOMPOSIZIONE NOTE (una sola volta) ---
    let note = modal.note || "";
    note = upsertNoteTag(note, "PF",  chk.fasciaDb);
    note = upsertNoteTag(note, "ORA", ora);
    if ((modal.moveReason || "").trim()) note = upsertNoteTag(note, "MOVE", modal.moveReason.trim());
    if (modal.comune?.trim())            note = upsertNoteTag(note, "CITTA", modal.comune.trim());

    // CAP sanificato (5 cifre)
    const capMove = String(modal.cap || "").replace(/\D/g, "").slice(0, 5);
    if (capMove.length === 5) {
      note = upsertNoteTag(note, "CAP", capMove);
    } else {
      // rimuovi eventuale CAP incoerente
      note = note.replace(/\[CAP:[^\]]+\]/ig, "").trim();
    }

    // Campanello + Presenze
    // Campanello + Presenze
    note = upsertNoteTag(note, "BELL", modal.bellState || "ok");
    note = upsertNoteTag(note, "PRES", modal.presenze ? "1" : "0");

    if (modal.presenze) {
      const byId = String(modal.presenzeBy || opId);
      note = upsertNoteTag(note, "PRES_BY", byId);

      const byName =
        (user?.nome ||
          user?.name ||
          user?.display_name ||
          user?.username ||
          user?.email ||
          `#${byId}`).toString().trim();
      note = upsertNoteTag(note, "PRES_BY_NAME", byName);
    } else {
      note = note.replace(/\[PRES_BY:[^\]]+\]/ig, "").trim();
      note = note.replace(/\[PRES_BY_NAME:[^\]]+\]/ig, "").trim();
    }


    // Ultima azione
    note = upsertNoteTag(note, "LAST", "move");

    // salva le note aggiornate (audit ui_last_action)
    const r2 = await postForm(`${API}/update_event.php`, {
      id,
      note,
      ui_last_action: "move",
      updated_by_operator_id: opId,
    });
    if (!r2.ok) console.warn("Update note dopo move: non riuscito");

    setModal((m) => ({ ...m, open: false }));
    setTick((t) => t + 1);
    notifyChanged(); // 🔔 sync altre tab
  } catch (err) {
    alert(err.message || "Errore spostamento");
  }
}

/* ---------- BLOCCO / SBLOCCO slot ---------- */
// ---------- BLOCCO / SBLOCCO slot ----------
// ---------- BLOCCO / SBLOCCO slot ----------
async function createBlockEvents(date, fascia, howMany) {
  if (!date || !fascia) return;
  const n = Math.max(0, Number(howMany) || 0);
  if (n === 0) return;

  const startHH = SLOT_TIME[fascia];
  const endHH   = addMinutesHHMM(startHH, 60);

  // nome operatore per audit (usa ciò che hai in auth)
  const opName =
    (user?.nome || user?.name || user?.email || `Operatore #${opId || ""}`).toString().trim();

  for (let i = 0; i < n; i++) {
    const res = await postForm(`${API}/save_event.php`, {
      zona_id: Number(zonaId),
      start_dt: `${date} ${startHH}:00`,
      end_dt:   `${date} ${endHH}:00`,
      fascia,
      nome_cliente: "BLOCCO",

      // 📵 niente telefono per i blocchi
      cliente_telefono: "",

      // audit nelle note: chi ha bloccato
      note: `[BLOCK:auto] [BLOCK_BY:${opName}] [BLOCK_BY_ID:${opId}] [LAST:block]`,
      created_by_operator_id: opId,

      // 👇 forza l’inserimento evitando 409 dovuti al check duplicati
      force: 1,
    });

    // accetta sia {status:"OK"} che {ok:true}; ignora eventuali DUPLICATE “morbidi”
    const ok = res && (res.status === "OK" || res.ok === true);
    if (!ok && res?.status !== "DUPLICATE") {
      throw new Error(res?.message || "Errore blocco");
    }
  }
}
async function blockFascia(date, fascia) {
  try {
    const cap = capFor(date, fascia);

    const arr    = bucketArr(date, fascia);
    const real   = arr.filter(e => !isBlockEventRaw(e) && isActiveEventRaw(e));
    const blocks = arr.filter(isBlockEventRaw);

    // quanti slot devo riempire con BLOCCO
    const free = Math.max(0, cap - (real.length + blocks.length));
    if (free <= 0) {
      alert("Nessuno slot libero da bloccare.");
      return;
    }

    await createBlockEvents(date, fascia, free); // createBlockEvents usa force:1

    // refresh + sync con altre tab/AgendaPro
    setTick(t => t + 1);
    try {
      new BroadcastChannel("agenda_sync").postMessage({ type: "changed", zonaId });
    } catch {}
  } catch (err) {
    alert(err?.message || "Errore blocco fascia");
  }
}





async function blockDay(date) {
  try {
    for (const f of ["M", "P", "S"]) {
      const cap = capFor(date, f);
      const { real, blocks } = splitBucket(date, f);
      const need = Math.max(0, cap - (real.length + blocks.length));
      if (need > 0) await createBlockEvents(date, f, need);
    }
    setTick(t => t + 1);
    try { new BroadcastChannel("agenda_sync").postMessage({ type: "changed", zonaId }); } catch {}
  } catch (err) {
    alert(err.message || "Errore blocco giorno");
  }
}

async function blockOne(date, fascia) {
  try {
    const cap = capFor(date, fascia);

    const arr     = bucketArr(date, fascia);
    const real    = arr.filter(e => !isBlockEventRaw(e) && isActiveEventRaw(e));
    const blocks  = arr.filter(isBlockEventRaw);

    const occ = real.length + blocks.length;
    if (occ >= cap) {
      alert("Fascia piena: nessuno slot libero da bloccare.");
      return;
    }

    await createBlockEvents(date, fascia, 1);

    setTick(t => t + 1);
    try { new BroadcastChannel("agenda_sync").postMessage({ type: "changed", zonaId }); } catch {}
  } catch (err) {
    alert(err?.message || "Errore blocco");
  }
}




// UNBLOCK: rimuove SOLO i blocchi (robusto)
async function deleteBlockEvent(id) {
  // 1) DELETE “duro”
  let res = await fetch(`${API}/delete_event.php`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "same-origin",
    body: JSON.stringify({ id: Number(id) }),
  });
  let j = await res.json().catch(() => ({}));
  const okDelete = res.ok && (!j.status || j.status === "OK");
  if (okDelete) return;

  // 2) fallback: annulla
  res = await fetch(`${API}/cancel_event.php`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "same-origin",
    body: JSON.stringify({
      id: Number(id),
      stato: "annullato",
      motivo: "auto-unblock",
      cancelled_by_operator_id: opId,
    }),
  });
  j = await res.json().catch(() => ({}));
  const okCancel = res.ok && (!j.status || j.status === "OK");
  if (!okCancel) {
    throw new Error(j.message || `HTTP ${res.status}`);
  }
}

async function unblockFascia(date, fascia) {
  try {
    const arr        = bucketArr(date, fascia);
    const blocks     = arr.filter(isBlockEventRaw);
    const toRemove   = blocks.filter(b => !isAssigned(b)); // SOLO blocchi senza assegnazione

    if (!toRemove.length) {
      alert("Nessun BLOCCO senza assegnazione da rimuovere.");
      return;
    }

    for (const b of toRemove) {
      await deleteBlockEvent(Number(b.id)); // usa la tua API esistente
    }

    setTick(t => t + 1);
    notifyChanged();
  } catch (err) {
    alert(err?.message || "Errore sblocca fascia");
  }
}


async function unblockDay(date) {
  try {
    for (const f of ["M", "P", "S"]) {
      const key = `${date}|${f}`;
      const blocks = (evBuckets[key] || []).filter(isBlockEventRaw);
      for (const b of blocks) await deleteBlockEvent(Number(b.id));
    }
    setTick(t => t + 1);
    notifyChanged();
  } catch (err) {
    alert(err.message || "Errore sblocca giorno");
  }
}


  /* ===== MINI-AGENDA (interna) ===== */
  function MiniAgendaPicker({ startYmd, selectedDate, selectedFascia, onPrevWeek, onNextWeek, onToday, onPick }) {
    const fasciaLabel = (f) => (f === "M" ? "Mattina" : f === "P" ? "Pomeriggio" : "Sera");
    const shortWeek = (d) => ["dom","lun","mar","mer","gio","ven","sab"][d.getDay()];

    const weekStart = new Date(startYmd + "T00:00:00");
    const daysList  = Array.from({ length: 7 }, (_, i) => addDays(weekStart, i));
    const weekEnd   = addDays(weekStart, 6);

    const Seat = ({ type }) => (
      <span
        style={{
          width: 12, height: 10, borderRadius: 3, display: "inline-block",
          background: type === "occ" ? "#94a3b8" : type === "blk" ? "#f59e0b" : "transparent",
          border: type ? "1px solid #cbd5e1" : "1px dashed #cbd5e1"
        }}
      />
    );
const renderCell = (date, fascia) => {
  const cap = capFor(date, fascia);
  const { real, blocks } = splitBucket(date, fascia);
  const all   = (evBuckets[`${date}|${fascia}`] || []);
  const canc  = all.filter(e => String(e?.stato || '').toLowerCase() === 'annullato').length;
  const conf  = all.filter(e => String(e?.stato || '').toLowerCase() === 'confermato' || !!e.confirmed_at).length;

  const liberi = Math.max(0, cap - (real.length + blocks.length));

  let status = "free";
  if (real.length >= cap) status = "full";
  else if (real.length + blocks.length >= cap && blocks.length > 0) status = "need";

  const bg = status === "free" ? "#ecfdf5" : status === "need" ? "#fff7ed" : "#fef2f2";
  const isSelected = selectedDate === date && selectedFascia === fascia;
  const border = isSelected ? `2px solid ${BRAND_RED}` : `1px solid ${SOFT_BORDER}`;

  const d = new Date(date + "T00:00:00");
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");

  return (
    <button
      type="button"
      key={`${date}-${fascia}`}
      onClick={() => onPick(date, fascia)}
      title={`${weekdayShort(d)} ${fasciaLabel(fascia)} — liberi:${liberi} annullati:${canc} confermati:${conf}`}
      style={{
        padding: 6,
        borderRadius: 12,
        minWidth: 116,           // leggermente più stretta
        background: bg,
        border,
        cursor: "pointer",
        display: "grid",
        gap: 6,
        boxShadow: isSelected ? `0 0 0 3px ${BRAND_RED}22` : "none",
      }}
    >
      {/* sedili 2x4 */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(4, 10px)", gridAutoRows:"8px", gap:2, justifyContent:"center" }}>
        {[
          ...Array.from({ length: Math.min(8, real.length) }, () => "occ"),
          ...Array.from({ length: Math.max(0, Math.min(8 - Math.min(8, real.length), blocks.length)) }, () => "blk"),
          ...Array.from({ length: Math.max(0, 8 - Math.min(8, real.length) - Math.min(8 - Math.min(8, real.length), blocks.length)) }, () => null),
        ].map((t, i) => (
          <span key={i} style={{
            width:10,height:8,borderRadius:3,display:"inline-block",
            background: t === "occ" ? "#94a3b8" : t === "blk" ? "#f59e0b" : "transparent",
            border: t ? "1px solid #cbd5e1" : "1px dashed #cbd5e1"
          }}/>
        ))}
      </div>

    {/* Testi compatti su 2 righe */}
<div style={{ textAlign: "center", lineHeight: 1.15 }}>
  <div style={{ fontSize: 12, fontWeight: 500 }}>
    {weekdayShort(d)} {fasciaLabel(fascia)} · <span style={{ fontSize: 15, fontWeight: 700 }}>{liberi}</span>
  </div>
  <div style={{ fontSize: 11, opacity: .9 }}>
    {dd}/{mm} · A:{canc} · C:{conf}
  </div>
</div>
    </button>
  );
};


    const fmtDay = (d) => `${String(d.getDate()).padStart(2,"0")}/${String(d.getMonth()+1).padStart(2,"0")}`;
    const rangeTitle = `${fmtDay(weekStart)} — ${fmtDay(weekEnd)}`;
    const cols = 7;
    const gridStyle = {
      display: "grid",
      gridTemplateColumns: `repeat(${cols}, minmax(116px, 1fr))`,
      gap: 6,
    };

    return (
      <div
        style={{
          marginTop: 8,
          padding: 10,
          border: `1px solid ${SOFT_BORDER}`,
          borderRadius: 10,
          background: "#fdeef0",
        }}
      >
        {/* Header navigazione */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            justifyContent: "space-between",
            marginBottom: 8,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <button type="button" onClick={onPrevWeek}
                    style={{ padding: "8px 14px", borderRadius: 999, border: `2px solid ${BRAND_RED}`, background: "#fff" }}>
              ←
            </button>
            <button type="button" onClick={onToday}
                    style={{ padding: "8px 14px", borderRadius: 999, border: `2px solid ${SOFT_BORDER}`, background: "#fff", fontWeight: 700 }}>
              Oggi
            </button>
            <button type="button" onClick={onNextWeek}
                    style={{ padding: "8px 14px", borderRadius: 999, border: `2px solid ${BRAND_RED}`, background: "#fff" }}>
              →
            </button>
          </div>

          <div style={{ fontWeight: 700, fontSize: 20 }}>{rangeTitle}</div>
        </div>

        {/* Griglia 3 righe (M/P/S) × 7 col — centrata */}
        <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
          <div style={{ ...gridStyle }}>
            {daysList.map((d) => renderCell(ymd(d), "M"))}
            {daysList.map((d) => renderCell(ymd(d), "P"))}
            {daysList.map((d) => renderCell(ymd(d), "S"))}
          </div>
        </div>

        {/* legenda sintetica */}
        <div style={{ marginTop: 8, fontSize: 12, display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", justifyContent: "center" }}>
          <span style={{ padding: "2px 8px", background: "#ecfdf5", border: `1px solid ${SOFT_BORDER}`, borderRadius: 999 }}>Libero</span>
          <span style={{ padding: "2px 8px", background: "#fff7ed", border: `1px solid ${SOFT_BORDER}`, borderRadius: 999 }}>Serve sbloccare</span>
          <span style={{ padding: "2px 8px", background: "#fef2f2", border: `1px solid ${SOFT_BORDER}`, borderRadius: 999 }}>Pieno</span>
          <span style={{ marginLeft: 12, opacity: .8 }}>⬛ occupato · 🟧 BLOCCO</span>
        </div>
      </div>
    );
  }

  /* ---------- UI ---------- */
  const legendDot = (bg, label) => (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 6, marginRight: 12 }}>
      <span style={{ width: 12, height: 12, borderRadius: 999, background: bg, display: "inline-block" }} />
      <span style={{ fontSize: 12 }}>{label}</span>
    </span>
  );

  return (
    <div className="page-container" style={{ padding: 6 }}>
      
      {/* FILTRI / CONTROLLI */}
<div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 6 }}>

  {/* ← indietro di N giorni */}
  <button
    type="button"
    onClick={() => shiftWindow(-1)}
    style={styles.navWeekBtn}
    title={`Indietro di ${days} giorni`}
  >
    ←
  </button>

  {/* Dal (stile pill come in modale) */}
  <div>
    <div style={styles.lbl}>Dal</div>
    <input
      type="date"
      value={start}
      onChange={(e) => setStart(e.target.value)}
      style={{
        padding: "8px 12px",
        borderRadius: 999,
        border: `2px solid ${SOFT_BORDER}`,
        outline: "none",
      }}
    />
  </div>

  {/* Giorni (stile pill) */}
  <div>
    <div style={styles.lbl}>Giorni</div>
    <input
      type="number"
      min={1}
      max={14}
      value={days}
      onChange={(e) => setDays(Number(e.target.value) || 7)}
      style={{
        width: 70,
        padding: "8px 12px",
        borderRadius: 999,
        border: `2px solid ${SOFT_BORDER}`,
        outline: "none",
      }}
    />
  </div>

  {/* Zona (stile pill) */}
  <div>
    <div style={styles.lbl}>Zona</div>
    <select
      value={zonaId}
      onChange={(e) => setZonaId(Number(e.target.value))}
      style={{
        padding: "8px 36px 8px 12px",
        borderRadius: 999,
        border: `2px solid ${SOFT_BORDER}`,
        outline: "none",
        appearance: "none",
      }}
    >
      {ZONE.map((z) => (
        <option key={z.id} value={z.id}>{z.label}</option>
      ))}
    </select>
  </div>

  {/* + Nuovo (stessa riga) */}
  <button
    type="button"
    onClick={openNewUniversal}
    style={{ ...styles.navWeekBtn, background: "#fff", border: `2px solid ${SOFT_BORDER}` }}
    title="Crea un nuovo appuntamento scegliendo prima giorno e fascia"
  >
    + Nuovo (scegli giorno)
  </button>

  {/* → avanti di N giorni */}
  <button
    type="button"
    onClick={() => shiftWindow(1)}
    style={styles.navWeekBtn}
    title={`Avanti di ${days} giorni`}
  >
    →
  </button>
</div>






      {/* LEGENDA (centrata) */}
{/* LEGENDA (centrata) */}
<div
  style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 12,
    flexWrap: "wrap",
    marginBottom: 6,
    fontSize: 13,
  }}
>
  <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
    <span style={{ width: 10, height: 10, background: "#9aa1a6", borderRadius: 999 }} />
    Prenotato
  </span>
  <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
    <span style={{ width: 10, height: 10, background: "#59c36a", borderRadius: 999 }} />
    Confermato
  </span>
  <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
    <span style={{ width: 10, height: 10, background: "#38bdf8", borderRadius: 999 }} />
    Assegnato
  </span>
  <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
    <span style={{ width: 10, height: 10, background: "#f5c542", borderRadius: 999 }} />
    Fase Senior
  </span>
  <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
    <span style={{ width: 10, height: 10, background: "#0f6c3d", borderRadius: 999 }} />
    Senior chiuso
  </span>
  <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
    <span style={{ width: 10, height: 10, background: "#e24d4d", borderRadius: 999 }} />
    Senior non chiuso
  </span>
  <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
    <span style={{ width: 10, height: 10, background: "#f6a623", borderRadius: 999 }} />
    BLOCCO
  </span>
 <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
   <span style={{ width: 10, height: 10, background: "#fff79a", borderRadius: 999 }} />
   Da spostare
 </span>



  <span style={{ fontSize: 12, opacity: 0.8, marginLeft: 8 }}>
    <b>BORDO ROSSO</b> = orario non coerente con fascia cliccata
  </span>
</div>
{/* GRIGLIA */}


<div style={{ overflowX: "auto" }}>




<table style={styles.grid}>
  <thead>
    <tr>
      <th
        style={{
          width: 110,
          textAlign: "left",
          paddingLeft: 8,
          fontSize: 12,
          fontWeight: 600,
        }}
      >
        Fascia
      </th>

      {daysList.map((d) => {
        const dStr = ymd(d);
        const stats = dayMarketingStats(dStr);

        return (
          <th
            key={dStr}
            style={{ textAlign: "center", verticalAlign: "top" }}
          >
            {/* griglia 2x2 che occupa il 100% della cella */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",   // 50% / 50%
                gridTemplateRows: "auto auto",
                columnGap: 8,
                rowGap: 2,                        // ⬅ meno spazio tra righe
                width: "100%",
              }}
            >
              {/* RIGA 1 - COLONNA 1: data */}
              <div
                style={{
                  textAlign: "center",
                }}
              >
                <div style={{ fontWeight: 700, fontSize: 14 }}>
                  {weekdayShort(d)}
                </div>
                <div style={{ fontSize: 16 }}>
                  {pad2(d.getDate())}/{pad2(d.getMonth() + 1)}
                </div>
              </div>

              {/* RIGA 1 - COLONNA 2: stats */}
             <div
  style={{
    fontSize: 8,
    lineHeight: 1,
    textAlign: "center",
  }}
>
  <div>
    Richiesti: <b>{stats.richiesti}</b>
  </div>
  <div>
    Dati: <b>{stats.consegnati}</b>
  </div>
  <div>
    Annullati: <b>{stats.annullati}</b>
  </div>
  <div>
    Bucati: <b>{stats.bucati}</b>
  </div>
</div>


              {/* RIGA 2 - COLONNA 1: Blocca giorno */}
              <div
                style={{
                  marginTop: 1,        // ⬅ meno margine sopra i bottoni
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <button
                  onClick={() => blockDay(dStr)}
                  style={{ fontSize: 11, padding: "2px 2px" }}
                  title="Riempie gli slot liberi con BLOCCO"
                >
                  Blocca giorno
                </button>
              </div>

              {/* RIGA 2 - COLONNA 2: Sblocca giorno */}
              <div
                style={{
                  marginTop: 1,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <button
                  onClick={() => unblockDay(dStr)}
                  style={{
                    fontSize: 11,
                    padding: "2px 2x",
                    background: "#fff",
                    border: "1px solid #aaa",
                    borderRadius: 6,
                  }}
                  title="Rimuove SOLO gli appuntamenti BLOCCO del giorno"
                >
                  Sblocca giorno
                </button>
              </div>
            </div>
          </th>
        );
      })}
    </tr>
  </thead>






    <tbody>
      {FASCIE.map((f) => (
        <tr key={f.code}>
          {/* COLONNA SINISTRA: Fascia + rilevatori + toggle */}
          <td
            style={{
              verticalAlign: "top",
              width: 120,
              paddingTop: 6,
              paddingLeft: 6,
            }}
          >
            {/* Box nome fascia + ora */}
            <div
              title={`${f.label} · ${f.time}`}
              style={{
                display: "inline-flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: 2,
                padding: "4px 8px",
                borderRadius: 8,
                background: "#f3f4f6",
                border: "1px solid #e5e7eb",
                lineHeight: 1.1,
                marginBottom: 4,
                minWidth: 110,
              }}
            >
              <span style={{ fontWeight: 700, fontSize: 11 }}>{f.label}</span>
              <span style={{ opacity: 0.8, fontSize: 11 }}>{f.time}</span>
            </div>

            {/* Rilevatori attivi (da DB) */}
            <div style={{ fontSize: 11, marginBottom: 4 }}>
              Rilevatori attivi:&nbsp;
              <strong>{activeRil ?? "…"}</strong>
            </div>

            {/* Pulsante pill: toggle globale evidenzia extra */}
            <button
              type="button"
              onClick={() => setHighlightExtra((v) => !v)}
              style={{
                padding: "4px 10px",
                borderRadius: 999,
                border: `1px solid ${BRAND_RED}`,
                background: highlightExtra ? BRAND_RED : "#fff",
                color: highlightExtra ? "#fff" : BRAND_RED,
                fontSize: 11,
                fontWeight: 700,
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
              }}
              title="Colora in giallo gli slot oltre il numero di rilevatori disponibili"
            >
              <span
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: 999,
                  background: highlightExtra ? "#facc15" : "transparent",
                  border: "1px solid #facc15",
                }}
              />
              {highlightExtra ? "Extra evidenziati" : "Evidenzia extra"}
            </button>
          </td>

          {/* COLONNE GIORNI */}
          {daysList.map((d) => {
            const date = ymd(d);
            const key = `${date}|${f.code}`;

            const meta = slotMap.get(key) || {
              free: capDefault,
              cap: capDefault,
            };
            const cap = Math.max(0, Number(meta.cap) || capDefault);
            const capCell = Math.min(SLOTS_PER_FASCIA, cap);

            const evs = Array.isArray(evBuckets[key]) ? evBuckets[key] : [];

            // 👉 BLOCCO in fondo, così gli annullati restano visibili se la fascia è piena
            const evsSorted = [...evs].sort((a, b) => {
              const aBlock = isBlockEventRaw(a) ? 1 : 0;
              const bBlock = isBlockEventRaw(b) ? 1 : 0;
              return aBlock - bBlock; // 0 prima, 1 dopo
            });

            // griglia fissa (massimo SLOTS_PER_FASCIA tile visivi)
            const POSITIONS = SLOTS_PER_FASCIA;
            const taken = Math.min(evsSorted.length, POSITIONS);

            // ====== marketing + extra ======
            const arrAll = evBuckets[key] || [];
            const isCancelled = (e) =>
              String(e?.stato || "").toLowerCase() === "annullato";
            const isConfirmed = (e) =>
              String(e?.stato || "").toLowerCase() === "confermato" ||
              !!e?.confirmed_at;

                     // solo appuntamenti che consumano 1 rilevatore attivo (prima fase)
            const realActiveArr = arrAll.filter((e) => countsAsRilevatoreSlot(e));




            const cancelled = arrAll.filter(isCancelled);
            const blocks = arrAll.filter(isBlockEventRaw);
            const toConfirm = realActiveArr.filter((e) => !isConfirmed(e))
              .length;



                          const used =
              realActiveArr.length + cancelled.length + blocks.length;
            const free = Math.max(0, capCell - Math.min(used, capCell));

            // override locale di rilevatori (senior che danno una mano)
           // override locale di rilevatori (senior che danno una mano)
// override locale di rilevatori (senior che danno una mano)
            const ovObj    = capOverrides[key] || { extra: 0 };
            const override = Number(ovObj.extra || 0);

            const baseRilZona = Number(activeRil ?? 0);

            // 👇 overlays: se c'è un evento AZIENDALE, blocca TUTTI i rilevatori
            const ovBlk = overlayBlocks[key] || { blocked: 0, globalRil: false };
            const blockedByOverlay = ovBlk.globalRil
              ? baseRilZona                     // evento aziendale → tutti occupati
              : Number(ovBlk.blocked || 0);     // overlay normali → solo quelli selezionati

            const baseRil = Math.max(0, baseRilZona - blockedByOverlay);

            const effectiveRil =
              baseRil + (Number.isFinite(override) ? override : 0);

            const isGlobalOverlay = !!ovBlk.globalRil;

            // modalità evidenzia extra:
            // - normale: oltre i rilevatori disponibili
            // - aziendale: SEMPRE ON (tutta la fascia gialla)
            const extraMode =
              highlightExtra &&
              (
                (Number.isFinite(effectiveRil) && effectiveRil > 0) ||
                isGlobalOverlay
              );





            const tiles = [];
            let realSeen = 0; // reali incontrati nella griglia (non blocco, non annullati)




            // --- EVENTI OCCUPATI (3 righe compatte) ---
            for (let i = 0; i < taken; i++) {
              const e = evsSorted[i];

              // === UI DB-driven (S0..S8) + fallback legacy ===
              const eCode = String(e.ui_state_code || "").toUpperCase();
              const isDaSpostare =
                eCode === "S10" ||
                String(e.stato || "").toLowerCase() === "da_spostare";
              const byDb = UI_BY_CODE[eCode];
              let ui = deriveEventUIFromRaw(e); // fallback legacy
              if (byDb)
                ui = {
                  bg: byDb.bg,
                  border: byDb.border,
                  showOnCall: byDb.showOnCall,
                  state: eCode,
                };

              const cancelledFlag = isCancelled(e) || eCode === "S8";
              const isBlock = isBlockEventRaw(e);
              const blockBy = isBlock
                ? getNoteTag(e.note, "BLOCK_BY") || ""
                : "";

              // titolo (BLOCCO oppure nome cliente)
              const baseName =
                (e.nome_cliente || e.cliente_nome || "").trim() || "Cliente";
              const title = isBlock ? "BLOCCO" : baseName;
              const display =
                title.length > 14 ? `${title.slice(0, 14)}…` : title;

              // ora/fascia per mismatch bordo
              const oraTag =
                (e.start_dt || "").slice(11, 16) ||
                getNoteTag(e.note, "ORA") ||
                SLOT_TIME[f.code];
              const calcF = fasciaForTime(oraTag);
              const mismatch = calcF !== f.code;

              let borderCol = cancelledFlag
                ? "#ef4444"
                : isDaSpostare
                ? "#e0d85c"
                : ui.border || (mismatch ? "#ef4444" : ACCENT_CYAN);

              let bgTile = cancelledFlag ? "#fee2e2" : ui.bg;
              // Manteniamo il bordeaux per annullati/da spostare; altrimenti calcolo automatico
              let txtTile =
                cancelledFlag || isDaSpostare
                  ? "#991b1b"
                  : textColorForBg(bgTile);

              // --- calcolo extra per questo evento ---
                         // --- calcolo extra per questo evento ---
              // conta come “slot rilevatore” SOLO se è di prima fase
              const contributes = countsAsRilevatoreSlot(e);
              if (contributes) realSeen++;

                const isExtra = extraMode && realSeen > effectiveRil;


              if (isExtra) {
                // override giallo acceso per extra
                bgTile = UI_COLORS.lemon; // #fff79a
                borderCol = "#eab308";
                txtTile = "#111";
              }


              tiles.push(
                <button
                  key={`ev-${key}-${e.id}`}
                  onClick={() => openEdit(e)}
                  title={[
                    title,
                    !isBlock
                      ? firstNonEmpty(
                          e.cliente_telefono,
                          e.cliente_tel,
                          e.telefono,
                          e.phone
                        ) || "—"
                      : undefined,
                  ]
                    .filter(Boolean)
                    .join("\n")}
                  style={{
                    ...styles.slot,
                    backgroundColor: bgTile,
                    color: txtTile,
                    borderColor: borderCol,
                    borderStyle: cancelledFlag ? "dashed" : "solid",
                    cursor: "pointer",
                  }}
                >
                  {/* riga 1: titolo */}
                  <div
                    style={{
                      fontWeight: 600,
                      fontSize: 12,
                      lineHeight: 1.1,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {display}
                  </div>

                  {/* riga 2: comune / “da NomeOperatore” per BLOCCO */}
                  <div
                    style={{
                      fontSize: 11,
                      lineHeight: 1.1,
                      opacity: 0.9,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {isBlock
                      ? blockBy
                        ? `da ${blockBy}`
                        : "—"
                      : firstNonEmpty(
                          e.comune,
                          e.citta,
                          e.cliente_comune,
                          e.paese,
                          e.paese_citta,
                          e.localita,
                          e.city,
                          e.town
                        ) || "—"}
                    {!isBlock &&
                      (() => {
                        const cap2 = firstNonEmpty(
                          e.cap,
                          e.CAP,
                          e.cliente_cap,
                          e.cap_cliente,
                          e.zip,
                          e.zip_code,
                          e.postal_code,
                          e.postalcode
                        );
                        return cap2 ? ` (${cap2})` : "";
                      })()}
                  </div>

                  {/* riga 3: telefono o “—” per BLOCCO */}
                  <div
                    style={{
                      fontSize: 11,
                      lineHeight: 1.1,
                      opacity: 0.9,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {isBlock
                      ? "—"
                      : firstNonEmpty(
                          e.cliente_telefono,
                          e.cliente_tel,
                          e.telefono,
                          e.phone
                        ) || "—"}
                  </div>
                </button>
              );
            }

            // --- SLOT LIBERI (numerati), mantieni capienza visiva ---
const freeToShow = Math.max(0, POSITIONS - taken);
for (let i = 0; i < freeToShow; i++) {
  const n = i + 1;

  const virtIdx = realActiveArr.length + i + 1;
  const freeIsExtra = extraMode && virtIdx > effectiveRil;

  const baseRil = Number(activeRil ?? 0);
  const isOpenedExtraSlot =
    override > 0 && virtIdx > baseRil && virtIdx <= baseRil + override;

  const actor   = (ovObj.byName || "").trim();
  const lastNote = (ovObj.lastNote || "").trim();
  const lastDelta = Number(ovObj.lastDelta || 0);

  let extraInfo = "";
  if (isOpenedExtraSlot && actor) {
    const actionWord = lastDelta >= 0 ? "aperto" : "chiuso";
    extraInfo =
      `\nSlot extra ${actionWord} da: ${actor}` +
      (lastNote ? ` — ${lastNote}` : "");
  }

  tiles.push(
    <button
      key={`free-${key}-${n}`}
      onClick={() => openNew(date, f.code)}
      onContextMenu={(ev) => {
        ev.preventDefault();
        toggleExtraOverride(date, f.code);
      }}
      title={
        `Nuovo appuntamento ${f.label} ${date}` +
        " — click destro: imposta slot extra" +
        extraInfo
      }
      style={{
        ...styles.slot,
        background: freeIsExtra ? "#fefce8" : "#fff",
        color: "#111",
        borderColor: freeIsExtra ? "#eab308" : ACCENT_CYAN,
      }}
    >
      {n}
    </button>
  );
}





            return (
              <td key={key} style={{ textAlign: "center", padding: 12 }}>
                <div style={styles.slotGrid}>{tiles}</div>

                {/* 📊 footer a due righe: pulsanti compatti + contatori centrati */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 6,
                    width: styles.slotActionsRow.width,
                  }}
                >
                  {/* riga 1: pulsanti compatti */}
                  <div
                    style={{
                      display: "flex",
                      gap: 6,
                      justifyContent: "center",
                      width: "100%",
                    }}
                  >
                    <button
                      style={{
                        padding: "3px 8px",
                        borderRadius: 8,
                        border: `1px solid ${SOFT_BORDER}`,
                        background: "#f9fafb",
                        fontSize: 11,
                        cursor: free > 0 ? "pointer" : "not-allowed",
                        opacity: free > 0 ? 1 : 0.5,
                      }}
                      onClick={() => free > 0 && blockOne(date, f.code)}
                      title={
                        free > 0 ? "Blocca uno slot" : "Nessuno slot libero"
                      }
                      disabled={free === 0}
                    >
                      Blocca 1
                    </button>
                    <button
                      style={{
                        padding: "3px 8px",
                        borderRadius: 8,
                        border: `1px solid ${SOFT_BORDER}`,
                        background: "#f9fafb",
                        fontSize: 11,
                        cursor: free > 0 ? "pointer" : "not-allowed",
                        opacity: free > 0 ? 1 : 0.5,
                      }}
                      onClick={() => free > 0 && blockFascia(date, f.code)}
                      title={
                        free > 0
                          ? "Blocca tutti i liberi"
                          : "Nessuno slot libero"
                      }
                      disabled={free === 0}
                    >
                      Blocca fascia
                    </button>
                    <button
                      style={{
                        padding: "3px 8px",
                        borderRadius: 8,
                        border: `1px solid ${SOFT_BORDER}`,
                        background: "#fff",
                        fontSize: 11,
                        cursor: "pointer",
                      }}
                      onClick={() => unblockFascia(date, f.code)}
                      title="Rimuove SOLO i BLOCCO senza assegnazione"
                    >
                      Sblocca fascia
                    </button>
                  </div>

                  {/* riga 2: contatori centrati */}
                  <div
                    style={{
                      fontSize: 12,
                      opacity: 0.85,
                      textAlign: "center",
                    }}
                  >
                    <b>{free}</b>/<b>{capCell}</b> liberi ·&nbsp; annullati:{" "}
                    <b>{cancelled.length}</b> ·&nbsp; da confermare:{" "}
                    <b>{toConfirm}</b>
                  </div>
                </div>
              </td>
            );
          })}
        </tr>
      ))}
    </tbody>

  </table>
</div>







      {/* MODALE */}
      {modal.open && (
<div
  style={styles.backdrop}
  onMouseDown={() => setModal((m) => ({ ...m, open: false }))}
  role="presentation"       // ✅ niente aria-hidden sull’antenato della modale
>

    <div
      style={styles.modal}
      onMouseDown={(e) => e.stopPropagation()}
      role="dialog"
      aria-modal="true"
      aria-labelledby="appointmentModalTitle"
      onKeyDown={(e) => {
        if (e.key === "Escape") setModal((m) => ({ ...m, open: false }));
      }}
      tabIndex={-1}
    >
      <div style={styles.modalHeader}>
        <strong id="appointmentModalTitle">
          {modal.mode === "new" ? "Nuovo appuntamento" : "Modifica appuntamento"} —{" "}
          {new Date(modal.date + "T00:00:00").toLocaleDateString("it-IT", {
            weekday: "short",
            day: "2-digit",
            month: "2-digit",
          })}{" "}
          · {FASCIE.find((x) => x.code === modal.fascia)?.label || ""}
        </strong>
        <button
          onClick={() => setModal((m) => ({ ...m, open: false }))}
          style={styles.xbtn}
          aria-label="Chiudi"
          type="button"
        >
          ×
        </button>
      </div>

      {/* Form dentro la modale */}
{/* BODY scrollabile + FORM */}



{/* BODY scrollabile + FORM */}
<div style={{ padding: 10, overflowY: "auto", maxHeight: "calc(96vh - 46px)" }}>
  <form onSubmit={submitModal}>
    {/* ====== RICERCA IN ALTO ====== */}
    <div style={{ marginBottom: 10 }}>
      <label style={{ ...styles.lbl, display: "block" }}>Cerca appuntamento esistente</label>
      <ExistingSearch
        zonaId={zonaId}
        date={modal.date}
        startHHMM={parseHHMM(modal.time) || SLOT_TIME[modal.fascia]}
        endHHMM={addMinutesHHMM(
          parseHHMM(modal.time) || SLOT_TIME[modal.fascia],
          modal.lunga ? 120 : 60
        )}
        canAccept={canAcceptHere}
        freeBlock={async (id) => {
          try { await deleteBlockEvent(id); } catch (e) { throw e; }
        }}
        onPrefill={(hit) => {
          setModal((m) => ({
            ...m,
            nome:      hit.nome_cliente      || m.nome,
            telefono:  hit.cliente_telefono  || m.telefono,
            email:     hit.cliente_email     || hit.email || m.email,
            indirizzo: hit.cliente_indirizzo || m.indirizzo,
            comune:    hit.comune            || m.comune,
            cap:       String(hit.cap || "").replace(/\D/g, "").slice(0, 5),
            note:      hit.note              || m.note,
          }));
        }}
        onMoved={() => {
          setModal((m) => ({ ...m, open: false }));
          setTick((t) => t + 1);
          notifyChanged();
        }}
        opId={opId}
      />
    </div>

    {/* ====== RIGA DATI CLIENTE (compatta + campanello) ====== */}
    <div
      style={{
        display: "grid",
        // 7 colonne: Nome | Tel | Email | Città | CAP | Indirizzo | Campanello
        gridTemplateColumns: "1.4fr 0.9fr 1.3fr 0.9fr 0.7fr 2fr 1.1fr",
        gap: 8,
        marginBottom: 8,
        alignItems: "end",
      }}
    >
      {/* Nome */}
      <div>
        <label style={styles.lbl} htmlFor="nome">Nome</label>
        <input
          id="nome"
          name="nome"
          maxLength={50}
          value={modal.nome}
          onChange={(e) => setModal({ ...modal, nome: e.target.value })}
          required
          autoComplete="name"
          style={{
            width: "100%",
            padding: "5px 10px",
            borderRadius: 10,
            border: `1px solid ${BRAND_RED}`,
            background: "#fff",
            outline: "none",
            fontSize: "0.9rem",
            lineHeight: 1.25,
          }}
        />
      </div>

      {/* Tel */}
      <div>
        <label style={styles.lbl} htmlFor="telefono">Tel.</label>
        <input
          id="telefono"
          name="telefono"
          type="tel"
          inputMode="tel"
          maxLength={15}
          value={modal.telefono}
          onChange={(e) => setModal({ ...modal, telefono: e.target.value })}
          required
          autoComplete="tel"
          pattern={String.raw`[0-9()+./ -]{7,}`}
          title="Inserisci un numero valido (min. 7 caratteri: cifre, spazi, +, -, /, ., parentesi)"
          style={{
            width: "100%",
            padding: "5px 10px",
            borderRadius: 10,
            border: `1px solid ${BRAND_RED}`,
            background: "#fff",
            outline: "none",
            fontSize: "0.9rem",
            lineHeight: 1.25,
          }}
        />
      </div>

      {/* Email (OBBLIGATORIA in AgendaCall) */}
      <div>
        <label style={styles.lbl} htmlFor="email">Email</label>
        <input
          id="email"
          name="email"
          type="email"
          value={modal.email}
          onChange={(e) => setModal({ ...modal, email: e.target.value })}
          required
          autoComplete="email"
          placeholder="nome.cognome@email.com"
          style={{
            width: "100%",
            padding: "5px 10px",
            borderRadius: 10,
            border: `1px solid ${BRAND_RED}`,
            background: "#fff",
            outline: "none",
            fontSize: "0.9rem",
            lineHeight: 1.25,
          }}
        />
      </div>

      {/* Città */}
      <div>
        <label style={styles.lbl} htmlFor="comune">Città</label>
        <input
          id="comune"
          name="comune"
          maxLength={45}
          value={modal.comune}
          onChange={(e) => setModal({ ...modal, comune: e.target.value })}
          autoComplete="address-level2"
          style={{
            width: "100%",
            padding: "5px 10px",
            borderRadius: 10,
            border: `1px solid ${BRAND_RED}`,
            background: "#fff",
            outline: "none",
            fontSize: "0.9rem",
            lineHeight: 1.25,
          }}
        />
      </div>

      {/* CAP */}
      <div>
        <label style={styles.lbl} htmlFor="cap">CAP</label>
        <input
          id="cap"
          name="cap"
          inputMode="numeric"
          type="text"
          maxLength={5}
          pattern="[0-9]{5}"
          title="CAP a 5 cifre"
          value={modal.cap}
          onChange={(e) =>
            setModal({
              ...modal,
              cap: e.target.value.replace(/\D/g, "").slice(0, 5),
            })
          }
          autoComplete="postal-code"
          style={{
            width: "100%",
            padding: "5px 10px",
            borderRadius: 10,
            border: `1px solid ${BRAND_RED}`,
            background: "#fff",
            outline: "none",
            fontSize: "0.9rem",
            lineHeight: 1.25,
          }}
        />
      </div>

      {/* Indirizzo */}
      <div>
        <label style={styles.lbl} htmlFor="indirizzo">Indirizzo</label>
        <input
          id="indirizzo"
          name="indirizzo"
          maxLength={120}
          value={modal.indirizzo}
          onChange={(e) => setModal({ ...modal, indirizzo: e.target.value })}
          autoComplete="street-address"
          style={{
            width: "100%",
            padding: "5px 10px",
            borderRadius: 10,
            border: `1px solid ${BRAND_RED}`,
            background: "#fff",
            outline: "none",
            fontSize: "0.9rem",
            lineHeight: 1.25,
          }}
        />
      </div>

      {/* Campanello */}
      <div style={{ display: "flex", alignItems: "end", justifyContent: "center" }}>
        <button
          type="button"
          onClick={() => {
            const order = ["ok", "rotto", "off"];
            const i = order.indexOf(modal.bellState || "ok");
            const next = order[(i + 1) % order.length];
            setModal(m => ({ ...m, bellState: next }));
          }}
          title={
            modal.bellState === "rotto" ? "Campanello rotto"
            : modal.bellState === "off" ? "No campanello"
            : "Campanello OK"
          }
          aria-label={
            modal.bellState === "rotto" ? "Campanello rotto"
            : modal.bellState === "off" ? "No campanello"
            : "Campanello OK"
          }
          style={{ all: "unset", cursor: "pointer", lineHeight: 0 }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              const order = ["ok", "rotto", "off"];
              const i = order.indexOf(modal.bellState || "ok");
              const next = order[(i + 1) % order.length];
              setModal(m => ({ ...m, bellState: next }));
            }
          }}
        >
          <img
            src={
              modal.bellState === "rotto"
                ? BELL_BROKEN_IMG
                : modal.bellState === "off"
                ? BELL_OFF_IMG
                : BELL_OK_IMG
            }
            alt=""
            width={24}
            height={24}
            draggable={false}
            style={{ display: "block", objectFit: "contain" }}
          />
        </button>
      </div>
    </div>
    {/* 👆 chiude SOLO la grid dei dati cliente, NON l’outer div scroll */}


        {/* ====== MINI-AGENDA CON NAV SETTIMANE ====== */}
        <div style={{ gridColumn: "1 / -1", marginBottom: 4 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 6,
            }}
          >
            <div style={{ fontWeight: 700 }}>Scegli giorno e fascia</div>
            <button
              type="button"
              onClick={() => setModal((m) => ({ ...m, pickerOpen: !m.pickerOpen }))}
              style={styles.ghostBtn}
              title="Apri/chiudi selettore compatto"
              aria-expanded={!!modal.pickerOpen}
              aria-controls="miniAgendaPicker"
            >
              {modal.pickerOpen ? "Nascondi" : "Apri"}
            </button>
          </div>

          {modal.pickerOpen && (
            <div id="miniAgendaPicker">
              <MiniAgendaPicker
                startYmd={pickerStart}
                selectedDate={modal.date}
                selectedFascia={modal.fascia}
                onPrevWeek={() =>
                  setPickerStart(ymd(addDays(new Date(pickerStart + "T00:00:00"), -7)))
                }
                onNextWeek={() =>
                  setPickerStart(ymd(addDays(new Date(pickerStart + "T00:00:00"), 7)))
                }
                onToday={() => setPickerStart(startOfWeekMonday(ymd(new Date())))}
                onPick={(date, fascia) => {
                  const hhmm = SLOT_TIME[fascia] || "09:00";
                  setModal((m) => ({
                    ...m,
                    date,
                    fascia,
                    time: hhmm,
                    moveDate: date,
                    moveTime: hhmm,
                  }));
                }}
              />
            </div>
          )}
        </div>




{/* Ora/Durata/Fascia + Quantità (+ libemax) */}
{/* Ora/Durata/Fascia + Quantità (+ libemax) — COMPATTA */}
<div style={{ gridColumn: "1 / span 3" }}>
  <div
    style={{
      display: "grid",
      // ~20% più stretta: colonne ridotte
      gridTemplateColumns: "110px 74px 46px 120px 50px repeat(5, 72px)",
      gap: 8,                         // prima 12
      alignItems: "end",
      justifyContent: "center",
    }}
  >
    {/* Ora inizio */}
    <div style={{ textAlign: "center" }}>
      <label
        htmlFor="oraInizio"
        style={{ ...styles.lbl, display: "block", textAlign: "center", marginBottom: 2 }}
      >
        Ora inizio *
      </label>
      <input
        id="oraInizio"
        name="oraInizio"
        type="time"
        value={modal.time}
        onChange={(e) => setModal((m) => ({ ...m, time: e.target.value }))}
        required
        style={{
          width: "100%",
          padding: "7px 10px",         // ⬅︎ –30% altezza
          borderRadius: 999,
          border: `1px solid ${BRAND_RED}`,
          background: "#fff",
          outline: "none",
          textAlign: "center",
          fontSize: 14,                // leggermente più compatto
        }}
      />
    </div>

    {/* Durata */}
    <div style={{ textAlign: "center" }}>
      <label style={{ ...styles.lbl, visibility: "hidden", marginBottom: 2 }}>Durata</label>
      <button
        type="button"
        onClick={() => setModal((m) => ({ ...m, lunga: !m.lunga }))}
        title="Alterna 60’ / 120’"
        aria-pressed={!!modal.lunga}
        style={{
          width: "100%",
          padding: "7px 10px",         // ⬅︎ –30% altezza
          borderRadius: 999,
          border: `1px solid ${BRAND_RED}`,
          background: modal.lunga ? BRAND_RED : "#fff",
          color: modal.lunga ? "#fff" : "#111",
          fontWeight: 800,
          fontSize: 14,
          cursor: "pointer",
          textAlign: "center",
        }}
      >
        ⏱ {modal.lunga ? "120’" : "60’"}
      </button>
    </div>

    {/* Ora fine */}
    <div style={{ textAlign: "center" }}>
      <label style={{ ...styles.lbl, visibility: "hidden", marginBottom: 2 }}>Fine</label>
      <div
        style={{ fontWeight: 800, textAlign: "center", paddingBottom: 0, fontSize: 18 }}
        aria-live="polite"
      >
        → {addMinutesHHMM(parseHHMM(modal.time) || SLOT_TIME[modal.fascia], modal.lunga ? 120 : 60)}
      </div>
    </div>

    {/* Fascia */}
    <div style={{ textAlign: "center" }}>
      <label
        htmlFor="fascia"
        style={{ ...styles.lbl, display: "block", textAlign: "center", marginBottom: 2 }}
      >
        Fascia
      </label>
      <select
        id="fascia"
        name="fascia"
        value={modal.fascia}
       onChange={(e) => {
   const newF = e.target.value;
   setModal((m) => {
     const oldDef = SLOT_TIME[m.fascia];
     const curr   = parseHHMM(m.time);
     const newDef = SLOT_TIME[newF];
     const keepTime = curr && curr !== oldDef; // l’utente l’aveva modificata a mano
     return { ...m, fascia: newF, time: keepTime ? curr : newDef };
   });
 }}
        style={{
          width: "100%",
          padding: "7px 10px",         // ⬅︎ –30% altezza
          borderRadius: 999,
          border: `1px solid ${BRAND_RED}`,
          background: "#fff",
          outline: "none",
          fontWeight: 700,
          textAlign: "center",
          fontSize: 14,
        }}
      >
        {FASCIE.map((f) => (
          <option key={f.code} value={f.code}>
            {f.label}
          </option>
        ))}
      </select>
    </div>

    {/* Presenze (solo icona Libemax, on/off) */}
    <div style={{ display: "flex", alignItems: "end", justifyContent: "center" }}>
      <button
        type="button"
        onClick={() =>
          setModal((m) => ({
            ...m,
            presenze: !m.presenze,
            presenzeBy: !m.presenze ? (m.presenzeBy ?? opId) : null,
          }))
        }
        title={
          modal.presenze
            ? `Inserito in Presenze (by #${modal.presenzeBy ?? opId})`
            : "Non inserito in Presenze"
        }
        aria-label={modal.presenze ? "Presenze inserito" : "Presenze non inserito"}
        style={{ all: "unset", cursor: "pointer", lineHeight: 0 }}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setModal((m) => ({
              ...m,
              presenze: !m.presenze,
              presenzeBy: !m.presenze ? (m.presenzeBy ?? opId) : null,
            }));
          }
        }}
      >
        <img
          src={modal.presenze ? PRES_ON_IMG : PRES_OFF_IMG}
          alt=""
          width={32}                     // leggermente più piccolo per coerenza con altezza ridotta
          height={32}
          draggable={false}
          style={{ display: "block", objectFit: "contain" }}
        />
      </button>
    </div>

    {/* Quantità */}
    {[
      ["Finestre", "qFin"],
      ["P-finestre", "qPF"],
      ["Portoncino", "qPor"],
      ["Blindato", "qBli"],
      ["Altro", "qAltro"],
    ].map(([label, key]) => (
      <div key={key} style={{ textAlign: "center" }}>
        <label
          htmlFor={key}
          style={{ ...styles.lbl, display: "block", textAlign: "center", marginBottom: 2 }}
        >
          {label}
        </label>
<input
  id={key}
  name={key}
  inputMode="numeric"
  type="text"
  pattern="[0-9]{1,2}"              // ✅ niente \d, niente ^...$, classe esplicita
  title="Inserisci un numero di 1–2 cifre"
  maxLength={2}
  placeholder="0"
  value={modal[key]}
  onChange={(e) =>
    setModal((m) => ({
      ...m,
      [key]: e.target.value.replace(/\D/g, "").slice(0, 2),
    }))
  }
  style={{
    width: "100%",
    padding: "8px 10px",
    borderRadius: 999,
    border: `1px solid ${BRAND_RED}`,
    background: "#fff",
    outline: "none",
    textAlign: "center",
    fontSize: 14,
  }}
/>


      </div>
    ))}
  </div>
</div>

{/* NOTE */}
<label style={styles.lbl} htmlFor="note">Note</label>
<textarea
  id="note"
  name="note"
  rows={3}                                  // 👈 parte da una riga
  value={modal.note}
  onChange={(e) => setModal((m) => ({ ...m, note: e.target.value }))}
  onInput={(e) => {                         // 👈 auto-resize
    e.currentTarget.style.height = "auto";
    const max = 200;                        // max px (puoi aumentare)
    e.currentTarget.style.height = Math.min(e.currentTarget.scrollHeight, max) + "px";
  }}
  placeholder="Informazioni utili per il tecnico…"
  style={{
    width: "100%",
    resize: "none",                         // niente maniglia (ci pensa l’auto-resize)
    padding: "8px 10px",
    borderRadius: 12,
    border: `2px solid ${BRAND_RED}`,
    background: "#fff",
    outline: "none",
    minHeight: 72,                          // 1 riga
    lineHeight: "1.2",
    overflow: "hidden",
  }}
/>

{/* AZIONI */}
<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 10, // was 12
    gap: 8,        // was 10
    flexWrap: "wrap",
  }}
>
  {modal.mode === "edit" ? (
    <>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        <button
          type="button"
          onClick={() => quickAction("confirm")}
          style={styles.primaryBtn}
          aria-label="Conferma appuntamento"
          title="Conferma appuntamento"
        >
          Conferma
        </button>

        <button
          type="button"
          onClick={() => quickAction("unconfirm")}
          style={styles.ghostBtn}
          disabled={String(modal.stato || "").toLowerCase() !== "confermato"}
          aria-label="Togli conferma"
          title="Togli conferma"
        >
          Togli conferma
        </button>

        <button
          type="button"
          onClick={() => quickAction("block")}
          style={styles.ghostBtn}
          aria-label="Blocca"
          title="Blocca"
        >
          Blocca
        </button>

        <button
          type="button"
          onClick={() => setModal((m) => ({ ...m, moveOpen: !m.moveOpen }))}
          style={styles.ghostBtn}
          aria-expanded={!!modal.moveOpen}
          aria-controls="movePanel"
          title={modal.moveOpen ? "Chiudi pannello sposta" : "Apri pannello sposta"}
        >
          {modal.moveOpen ? "Chiudi sposta" : "Sposta"}
        </button>

          <button
          type="button"
          onClick={() => quickAction("da_spostare")}
          style={styles.daSpostareBtn}
          aria-label="Marca come da spostare"
          title="Marca come da spostare (non assegnabile finché non cambia stato)"
        >
          Da spostare
        </button>



        <button
          type="button"
          onClick={() => quickAction("cancel")}
          style={styles.dangerBtn}
          aria-label="Annulla appuntamento"
          title="Annulla appuntamento"
        >
          Annulla
        </button>
      </div>

      {modal.moveOpen && (
        <div
          id="movePanel"
          style={{
            width: "100%",
            marginTop: 8, // was 10
            background: "#f9fafb",
            padding: 8,   // was 10
            borderRadius: 8,
            border: `1px solid ${SOFT_BORDER}`,
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "140px 120px 1fr auto",
              gap: 8,
              alignItems: "end",
            }}
          >
            <div>
              <label style={styles.lbl} htmlFor="moveDate">Nuova data</label>
              <input
                id="moveDate"
                type="date"
                value={modal.moveDate}
                onChange={(e) => setModal((m) => ({ ...m, moveDate: e.target.value }))}
                required
                style={{
                  width: "100%",
                  padding: "8px 10px",
                  borderRadius: 12,
                  border: `2px solid ${BRAND_RED}`,
                  background: "#fff",
                  outline: "none",
                }}
              />
            </div>

            <div>
              <label style={styles.lbl} htmlFor="moveTime">Nuova ora</label>
              <input
                id="moveTime"
                type="time"
                value={modal.moveTime}
                onChange={(e) => setModal((m) => ({ ...m, moveTime: e.target.value }))}
                required
                style={{
                  width: "100%",
                  padding: "8px 10px",
                  borderRadius: 12,
                  border: `2px solid ${BRAND_RED}`,
                  background: "#fff",
                  outline: "none",
                }}
              />
            </div>

            <div>
              <label style={styles.lbl} htmlFor="moveReason">Motivo spostamento</label>
              <input
                id="moveReason"
                value={modal.moveReason}
                onChange={(e) => setModal((m) => ({ ...m, moveReason: e.target.value }))}
                placeholder="Es. richiesta cliente"
                maxLength={120}
                style={{
                  width: "100%",
                  padding: "8px 10px",
                  borderRadius: 12,
                  border: `2px solid ${BRAND_RED}`,
                  background: "#fff",
                  outline: "none",
                }}
              />
            </div>

            <div>
              <button
                type="button"
                onClick={doMove}
                style={styles.primaryBtn}
                aria-label="Conferma spostamento"
                title="Conferma spostamento"
              >
                Conferma spostamento
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  ) : (
    <span />
  )}

  <div style={{ marginLeft: "auto", display: "flex", gap: 8 }}>
    <button
      type="button"
      onClick={() => setModal((m) => ({ ...m, open: false }))}
      style={{ ...styles.ghostBtn }}
      aria-label="Chiudi senza salvare"
      title="Chiudi senza salvare"
    >
      Annulla
    </button>

    <button
      type="submit"
      style={styles.primaryBtn}
      aria-label={modal.mode === "new" ? "Salva appuntamento" : "Aggiorna appuntamento"}
      title={modal.mode === "new" ? "Salva appuntamento" : "Aggiorna appuntamento"}
    >
      {modal.mode === "new" ? "Salva" : "Aggiorna"}
    </button>
  </div>
</div>

      </form>
    </div> 
  </div>   
</div>     
)}        

</div>    
);         // chiude return
}          // chiude componente AgendaCall

/* ======================= STILI ======================= */
const styles = {
  lbl: { fontSize: 12, opacity: 0.8, marginBottom: 4 },

  grid: {
    width: "100%",
    background: "#fff",
    borderRadius: 10,
    boxShadow: "0 8px 20px rgba(0,0,0,.06)",
  },

  // slot (griglia principale)
  slot: {
    width: SLOT_W,
    height: SLOT_H,
    padding: "5px 8px",
    borderRadius: SLOT_RADIUS,
    border: `2px solid ${ACCENT_CYAN}`,
    background: "#fff",
    color: "#111",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "center",
    gap: 1,
  },

  slotLine: {
    fontWeight: 700,
    fontSize: SLOT_FONT,
    lineHeight: 1.1,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  slotLineSecondary: {
    fontSize: SLOT_FONT - 1,
    lineHeight: 1.1,
    opacity: 0.85,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  slotGrid: {
    width: GRID_COLS * SLOT_W + (GRID_COLS - 1) * SLOT_GAP,
    display: "grid",
    gridTemplateColumns: `repeat(${GRID_COLS}, ${SLOT_W}px)`,
    gridAutoRows: `${SLOT_H}px`,
    gap: SLOT_GAP,
    justifyContent: "center",
  },

  slotActionsRow: {
    width: GRID_COLS * SLOT_W + (GRID_COLS - 1) * SLOT_GAP,
    marginTop: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  // bottone piccolo (Blocca 1 / Blocca fascia / Sblocca)
  smallBtn: {
    padding: "4px 8px",
    borderRadius: 8,
    border: `1px solid ${SOFT_BORDER}`,
    background: "#f9fafb",
    fontSize: 12,
    cursor: "pointer",
  },

  // --- input/select/textarea
  input: {
    width: "100%",
    height: 40,
    padding: "8px 12px",
    borderRadius: 12,
    border: `2px solid ${SOFT_BORDER}`,
    background: "#fff",
    outline: "none",
    boxShadow: `inset 0 0 0 0 ${BRAND_RED_SOFT_RING}`,
  },

  select: {
    width: "100%",
    height: 40,
    padding: "8px 36px 8px 12px",
    borderRadius: 999,
    border: `2px solid ${SOFT_BORDER}`,
    background: "#fff",
    outline: "none",
    appearance: "none",
  },

  textarea: {
    width: "100%",
    minHeight: 56,
    padding: "8px 12px",
    borderRadius: 12,
    border: `2px solid ${SOFT_BORDER}`,
    background: "#fff",
  },

  searchInput: {
    width: "100%",
    height: 40,
    padding: "8px 12px",
    borderRadius: 12,
    border: `2px solid #111`,
    background: "#fff",
    boxShadow: `0 0 0 4px transparent`,
  },

  // bottoni
  primaryBtn: {
    padding: "8px 14px",
    borderRadius: 10,
    border: `1px solid ${BRAND_RED_DARK}`,
    backgroundImage: BRAND_GRADIENT,
    backgroundColor: BRAND_RED,
    color: "#fff",
    fontWeight: 800,
    cursor: "pointer",
  },

  ghostBtn: {
    padding: "8px 12px",
    borderRadius: 10,
    border: `1px solid ${SOFT_BORDER}`,
    background: "#fff",
    cursor: "pointer",
  },

  dangerBtn: {
    padding: "8px 12px",
    borderRadius: 10,
    border: `1px solid ${BRAND_RED_DARK}`,
    background: "#fee2e2",
    color: BRAND_RED,
    fontWeight: 800,
    cursor: "pointer",
  },

daSpostareBtn: {
    padding: "8px 12px",
    borderRadius: 10,
    border: "1px solid #e0d85c",
    background: "#fff79a",
    color: "#333",
    fontWeight: 800,
    cursor: "pointer",
  },

  pillToggle: {
    padding: "8px 14px",
    borderRadius: 999,
    border: `2px solid ${SOFT_BORDER}`,
    background: "#fff",
    fontWeight: 800,
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
  },

  // Nav settimana
  navWeekBtn: {
    padding: "6px 10px",
    borderRadius: 999,
    border: `2px solid ${BRAND_RED}`,
    background: BRAND_RED_SOFT_BG,
    color: BRAND_RED,
    fontWeight: 800,
    cursor: "pointer",
  },

  // modale
  backdrop: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,.38)",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    paddingTop: 28,
    zIndex: 1200,
  },

    modal: {
    background: "#fff",
    width: "min(980px, 95vw)",
    borderRadius: 12,
    overflow: "hidden",
    boxShadow: "0 18px 50px rgba(0,0,0,.35)",
    maxHeight: "96vh",              // 👈 prima era 90vh
    display: "flex",
    flexDirection: "column",
  },


  modalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px 10px",
    borderBottom: "1px solid #eee",
    background: "#fef2f2",
  },

  xbtn: {
    border: "none",
    background: "transparent",
    fontSize: 22,
    lineHeight: 1,
    cursor: "pointer",
  },



};
